/* eslint-disable */
// This file is auto-generated by @hey-api/openapi-ts
// Build from env v65.0.0-rc.4
// File ./data/openapi.yaml
// Build 42009504488
// Artifact https://api.github.com/repos/Konova-AG/emi-api/actions/artifacts/13405644476/zip
// Built at 2026-11-05T11:01:46.091Z

import { type Client, formDataBodySerializer, type Options as Options2, type TDataShape } from './client';
import { client } from './client.gen';
import type { DeleteApiV1CommentsIdData, DeleteApiV1CommentsIdErrors, DeleteApiV1CommentsIdResponses, DeleteApiV1EvaluationGroupReactionFieldsIdData, DeleteApiV1EvaluationGroupReactionFieldsIdErrors, DeleteApiV1EvaluationGroupReactionFieldsIdResponses, DeleteApiV1EvaluationPageSettingsIdData, DeleteApiV1EvaluationPageSettingsIdErrors, DeleteApiV1EvaluationPageSettingsIdResponses, DeleteApiV1FeedbackTagsIdData, DeleteApiV1FeedbackTagsIdErrors, DeleteApiV1FeedbackTagsIdResponses, DeleteApiV1IdeaBoardEntriesBulkDestroyData, DeleteApiV1IdeaBoardEntriesBulkDestroyErrors, DeleteApiV1IdeaBoardEntriesBulkDestroyResponses, DeleteApiV1IdeaBoardEntriesIdData, DeleteApiV1IdeaBoardEntriesIdErrors, DeleteApiV1IdeaBoardEntriesIdResponses, DeleteApiV1ParticipantGroupsParticipantGroupIdData, DeleteApiV1ParticipantGroupsParticipantGroupIdErrors, DeleteApiV1ParticipantGroupsParticipantGroupIdResponses, DeleteApiV1ParticipantGroupsParticipantGroupIdUsersSpaceUserIdData, DeleteApiV1ParticipantGroupsParticipantGroupIdUsersSpaceUserIdErrors, DeleteApiV1ParticipantGroupsParticipantGroupIdUsersSpaceUserIdResponses, DeleteApiV1ParticipantGroupTagsIdData, DeleteApiV1ParticipantGroupTagsIdErrors, DeleteApiV1ParticipantGroupTagsIdResponses, DeleteApiV1ParticipantImportFilesIdData, DeleteApiV1ParticipantImportFilesIdErrors, DeleteApiV1ParticipantImportFilesIdResponses, DeleteApiV1SingleSignOnsIdData, DeleteApiV1SingleSignOnsIdErrors, DeleteApiV1SingleSignOnsIdResponses, DeleteApiV1SpaceAssetsIdData, DeleteApiV1SpaceAssetsIdErrors, DeleteApiV1SpaceAssetsIdResponses, DeleteApiV1SpaceEmailTemplatesIdData, DeleteApiV1SpaceEmailTemplatesIdErrors, DeleteApiV1SpaceEmailTemplatesIdResponses, DeleteApiV1SpacesSpaceIdAdminsSpaceUserIdData, DeleteApiV1SpacesSpaceIdAdminsSpaceUserIdErrors, DeleteApiV1SpacesSpaceIdAdminsSpaceUserIdResponses, DeleteApiV1SpacesSpaceIdFaviconData, DeleteApiV1SpacesSpaceIdFaviconErrors, DeleteApiV1SpacesSpaceIdFaviconResponses, DeleteApiV1SpacesSpaceIdTermsOfUsePdfData, DeleteApiV1SpacesSpaceIdTermsOfUsePdfErrors, DeleteApiV1SpacesSpaceIdTermsOfUsePdfResponses, DeleteApiV1SpacesSpaceIdUsersUserIdData, DeleteApiV1SpacesSpaceIdUsersUserIdErrors, DeleteApiV1SpacesSpaceIdUsersUserIdResponses, DeleteApiV1SpaceUsersSpaceUserIdData, DeleteApiV1SpaceUsersSpaceUserIdErrors, DeleteApiV1SpaceUsersSpaceUserIdResponses, DeleteApiV1SurveyCategoriesIdData, DeleteApiV1SurveyCategoriesIdResponses, DeleteApiV1SurveyDocumentContentAttachmentsSurveyDocumentContentAttachmentIdData, DeleteApiV1SurveyDocumentContentAttachmentsSurveyDocumentContentAttachmentIdErrors, DeleteApiV1SurveyDocumentContentAttachmentsSurveyDocumentContentAttachmentIdResponses, DeleteApiV1SurveyDocumentContentsBulkData, DeleteApiV1SurveyDocumentContentsBulkErrors, DeleteApiV1SurveyDocumentContentsBulkResponses, DeleteApiV1SurveyDocumentContentsCmsIdData, DeleteApiV1SurveyDocumentContentsCmsIdErrors, DeleteApiV1SurveyDocumentContentsCmsIdResponses, DeleteApiV1SurveyDocumentContentsIdData, DeleteApiV1SurveyDocumentContentsIdErrors, DeleteApiV1SurveyDocumentContentsIdResponses, DeleteApiV1SurveyDocumentFeedbackEvaluationGroupReactionsEvaluationGroupReactionIdData, DeleteApiV1SurveyDocumentFeedbackEvaluationGroupReactionsEvaluationGroupReactionIdErrors, DeleteApiV1SurveyDocumentFeedbackEvaluationGroupReactionsEvaluationGroupReactionIdResponses, DeleteApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupData, DeleteApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupErrors, DeleteApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupResponses, DeleteApiV1SurveyDocumentFeedbackGroupsIdData, DeleteApiV1SurveyDocumentFeedbackGroupsIdErrors, DeleteApiV1SurveyDocumentFeedbackGroupsIdResponses, DeleteApiV1SurveyDocumentFeedbacksIdData, DeleteApiV1SurveyDocumentFeedbacksIdErrors, DeleteApiV1SurveyDocumentFeedbacksIdResponses, DeleteApiV1SurveyDocumentGroupsIdData, DeleteApiV1SurveyDocumentGroupsIdErrors, DeleteApiV1SurveyDocumentGroupsIdResponses, DeleteApiV1SurveyDocumentGroupTagsIdData, DeleteApiV1SurveyDocumentGroupTagsIdErrors, DeleteApiV1SurveyDocumentGroupTagsIdResponses, DeleteApiV1SurveyDocumentPageAreasByLanguageData, DeleteApiV1SurveyDocumentPageAreasByLanguageErrors, DeleteApiV1SurveyDocumentPageAreasByLanguageResponses, DeleteApiV1SurveyDocumentPageAreasIdData, DeleteApiV1SurveyDocumentPageAreasIdErrors, DeleteApiV1SurveyDocumentPageAreasIdResponses, DeleteApiV1SurveyDocumentQuestionsIdData, DeleteApiV1SurveyDocumentQuestionsIdErrors, DeleteApiV1SurveyDocumentQuestionsIdResponses, DeleteApiV1SurveyDocumentsIdData, DeleteApiV1SurveyDocumentsIdErrors, DeleteApiV1SurveyDocumentsIdResponses, DeleteApiV1SurveyDocumentTagsIdData, DeleteApiV1SurveyDocumentTagsIdErrors, DeleteApiV1SurveyDocumentTagsIdResponses, DeleteApiV1SurveyEmailTemplateAttachmentSurveyEmailTemplateAttachmentIdData, DeleteApiV1SurveyEmailTemplateAttachmentSurveyEmailTemplateAttachmentIdErrors, DeleteApiV1SurveyEmailTemplateAttachmentSurveyEmailTemplateAttachmentIdResponses, DeleteApiV1SurveyEmailTemplatesIdData, DeleteApiV1SurveyEmailTemplatesIdErrors, DeleteApiV1SurveyEmailTemplatesIdResponses, DeleteApiV1SurveyExportsIdData, DeleteApiV1SurveyExportsIdErrors, DeleteApiV1SurveyExportsIdResponses, DeleteApiV1SurveyModuleAnswersIdData, DeleteApiV1SurveyModuleAnswersIdErrors, DeleteApiV1SurveyModuleAnswersIdResponses, DeleteApiV1SurveyModuleQuestionsIdData, DeleteApiV1SurveyModuleQuestionsIdErrors, DeleteApiV1SurveyModuleQuestionsIdResponses, DeleteApiV1SurveyModuleQuestionsSurveyModuleQuestionIdDeleteAnswersData, DeleteApiV1SurveyModuleQuestionsSurveyModuleQuestionIdDeleteAnswersErrors, DeleteApiV1SurveyModuleQuestionsSurveyModuleQuestionIdDeleteAnswersResponses, DeleteApiV1SurveysIdData, DeleteApiV1SurveysIdErrors, DeleteApiV1SurveysIdResponses, DeleteApiV1SurveysSurveyIdUsersSpaceUserIdData, DeleteApiV1SurveysSurveyIdUsersSpaceUserIdErrors, DeleteApiV1SurveysSurveyIdUsersSpaceUserIdResponses, DeleteApiV1SurveyStagesIdData, DeleteApiV1SurveyStagesIdErrors, DeleteApiV1SurveyStagesIdResponses, GetApiV1AllSpacesData, GetApiV1AllSpacesResponses, GetApiV1CommentsData, GetApiV1CommentsErrors, GetApiV1CommentsIdData, GetApiV1CommentsIdErrors, GetApiV1CommentsIdResponses, GetApiV1CommentsResponses, GetApiV1EvaluationGroupReactionFieldsData, GetApiV1EvaluationGroupReactionFieldsErrors, GetApiV1EvaluationGroupReactionFieldsIdData, GetApiV1EvaluationGroupReactionFieldsIdErrors, GetApiV1EvaluationGroupReactionFieldsIdResponses, GetApiV1EvaluationGroupReactionFieldsResponses, GetApiV1EvaluationPageSettingsData, GetApiV1EvaluationPageSettingsErrors, GetApiV1EvaluationPageSettingsResponses, GetApiV1EventLogsData, GetApiV1EventLogsErrors, GetApiV1EventLogsResponses, GetApiV1FeedbackTagsData, GetApiV1FeedbackTagsErrors, GetApiV1FeedbackTagsIdData, GetApiV1FeedbackTagsIdErrors, GetApiV1FeedbackTagsIdResponses, GetApiV1FeedbackTagsResponses, GetApiV1HealthCheckData, GetApiV1HealthCheckResponses, GetApiV1IdeaBoardEntriesData, GetApiV1IdeaBoardEntriesErrors, GetApiV1IdeaBoardEntriesExcelData, GetApiV1IdeaBoardEntriesExcelErrors, GetApiV1IdeaBoardEntriesExcelExportUrlData, GetApiV1IdeaBoardEntriesExcelExportUrlErrors, GetApiV1IdeaBoardEntriesExcelExportUrlResponses, GetApiV1IdeaBoardEntriesExcelResponses, GetApiV1IdeaBoardEntriesIdData, GetApiV1IdeaBoardEntriesIdErrors, GetApiV1IdeaBoardEntriesIdResponses, GetApiV1IdeaBoardEntriesResponses, GetApiV1LocalesLangTranslationJsonData, GetApiV1LocalesLangTranslationJsonResponses, GetApiV1OauthPasswordResetLeftTimeData, GetApiV1OauthPasswordResetLeftTimeErrors, GetApiV1OauthPasswordResetLeftTimeResponses, GetApiV1OauthSpaceUserSpaceUserIdActivateData, GetApiV1OauthSpaceUserSpaceUserIdActivateResponses, GetApiV1OauthUserData, GetApiV1OauthUserResponses, GetApiV1OauthUserUserIdActivateData, GetApiV1OauthUserUserIdActivateResponses, GetApiV1ParticipantGroupsData, GetApiV1ParticipantGroupsErrors, GetApiV1ParticipantGroupsExportData, GetApiV1ParticipantGroupsExportErrors, GetApiV1ParticipantGroupsExportResponses, GetApiV1ParticipantGroupsExportUrlData, GetApiV1ParticipantGroupsExportUrlErrors, GetApiV1ParticipantGroupsExportUrlResponses, GetApiV1ParticipantGroupsParticipantGroupIdData, GetApiV1ParticipantGroupsParticipantGroupIdErrors, GetApiV1ParticipantGroupsParticipantGroupIdFeedbackForSurveySurveyIdPdfData, GetApiV1ParticipantGroupsParticipantGroupIdFeedbackForSurveySurveyIdPdfErrors, GetApiV1ParticipantGroupsParticipantGroupIdFeedbackForSurveySurveyIdPdfResponses, GetApiV1ParticipantGroupsParticipantGroupIdResponses, GetApiV1ParticipantGroupsParticipantGroupIdUsersData, GetApiV1ParticipantGroupsParticipantGroupIdUsersErrors, GetApiV1ParticipantGroupsParticipantGroupIdUsersResponses, GetApiV1ParticipantGroupsResponses, GetApiV1ParticipantGroupTagsData, GetApiV1ParticipantGroupTagsErrors, GetApiV1ParticipantGroupTagsIdData, GetApiV1ParticipantGroupTagsIdErrors, GetApiV1ParticipantGroupTagsIdResponses, GetApiV1ParticipantGroupTagsResponses, GetApiV1ParticipantImportFilesData, GetApiV1ParticipantImportFilesErrors, GetApiV1ParticipantImportFilesIdData, GetApiV1ParticipantImportFilesIdErrors, GetApiV1ParticipantImportFilesIdResponses, GetApiV1ParticipantImportFilesResponses, GetApiV1ParticipantsGetCountOnStageData, GetApiV1ParticipantsGetCountOnStageErrors, GetApiV1ParticipantsGetCountOnStageResponses, GetApiV1ParticipantsImportTemplateData, GetApiV1ParticipantsImportTemplateResponses, GetApiV1PlatformFeedbacksData, GetApiV1PlatformFeedbacksErrors, GetApiV1PlatformFeedbacksIdData, GetApiV1PlatformFeedbacksIdErrors, GetApiV1PlatformFeedbacksIdResponses, GetApiV1PlatformFeedbacksResponses, GetApiV1SingleSignOnsData, GetApiV1SingleSignOnsErrors, GetApiV1SingleSignOnsResponses, GetApiV1SpaceAssetsData, GetApiV1SpaceAssetsErrors, GetApiV1SpaceAssetsIdData, GetApiV1SpaceAssetsIdErrors, GetApiV1SpaceAssetsIdResponses, GetApiV1SpaceAssetsResponses, GetApiV1SpaceAssetsSpaceAssetIdDownloadFilenameData, GetApiV1SpaceAssetsSpaceAssetIdDownloadFilenameResponses, GetApiV1SpaceEmailTemplatesData, GetApiV1SpaceEmailTemplatesErrors, GetApiV1SpaceEmailTemplatesIdData, GetApiV1SpaceEmailTemplatesIdErrors, GetApiV1SpaceEmailTemplatesIdResponses, GetApiV1SpaceEmailTemplatesResponses, GetApiV1SpacesData, GetApiV1SpacesIdData, GetApiV1SpacesIdErrors, GetApiV1SpacesIdResponses, GetApiV1SpacesResponses, GetApiV1SpacesSpaceIdLogoData, GetApiV1SpacesSpaceIdLogoErrors, GetApiV1SpaceUsersData, GetApiV1SpaceUsersErrors, GetApiV1SpaceUsersResponses, GetApiV1SsoAzureCallbackData, GetApiV1SsoAzureCallbackErrors, GetApiV1SsoAzureRedirectUrlData, GetApiV1SsoAzureRedirectUrlErrors, GetApiV1SsoAzureRedirectUrlResponses, GetApiV1SsoBsCallbackData, GetApiV1SsoBsCallbackErrors, GetApiV1SsoBsRedirectUrlData, GetApiV1SsoBsRedirectUrlErrors, GetApiV1SsoBsRedirectUrlResponses, GetApiV1SsoEZugCallbackData, GetApiV1SsoEZugCallbackErrors, GetApiV1SsoEZugRedirectUrlData, GetApiV1SsoEZugRedirectUrlErrors, GetApiV1SsoEZugRedirectUrlResponses, GetApiV1StorageFilesPathData, GetApiV1SubmissionsData, GetApiV1SubmissionsErrors, GetApiV1SubmissionsPublicData, GetApiV1SubmissionsPublicErrors, GetApiV1SubmissionsPublicResponses, GetApiV1SubmissionsResponses, GetApiV1SupportZohoOauthData, GetApiV1SupportZohoOauthResponses, GetApiV1SurveyCategoriesData, GetApiV1SurveyCategoriesErrors, GetApiV1SurveyCategoriesIdData, GetApiV1SurveyCategoriesIdResponses, GetApiV1SurveyCategoriesResponses, GetApiV1SurveyDocumentContentsCmsData, GetApiV1SurveyDocumentContentsCmsErrors, GetApiV1SurveyDocumentContentsCmsIdData, GetApiV1SurveyDocumentContentsCmsIdErrors, GetApiV1SurveyDocumentContentsCmsIdResponses, GetApiV1SurveyDocumentContentsCmsResponses, GetApiV1SurveyDocumentContentsCmsSurveyDocumentContentCmsDataIdDownloadData, GetApiV1SurveyDocumentContentsCmsSurveyDocumentContentCmsDataIdDownloadErrors, GetApiV1SurveyDocumentContentsData, GetApiV1SurveyDocumentContentsErrors, GetApiV1SurveyDocumentContentsIdData, GetApiV1SurveyDocumentContentsIdErrors, GetApiV1SurveyDocumentContentsIdResponses, GetApiV1SurveyDocumentContentsImportTemplateData, GetApiV1SurveyDocumentContentsImportTemplateErrors, GetApiV1SurveyDocumentContentsImportTemplateResponses, GetApiV1SurveyDocumentContentsResponses, GetApiV1SurveyDocumentFeedbackEvaluationGroupReactionsData, GetApiV1SurveyDocumentFeedbackEvaluationGroupReactionsErrors, GetApiV1SurveyDocumentFeedbackEvaluationGroupReactionsResponses, GetApiV1SurveyDocumentFeedbackEvaluationGroupsData, GetApiV1SurveyDocumentFeedbackEvaluationGroupsErrors, GetApiV1SurveyDocumentFeedbackEvaluationGroupsExcelData, GetApiV1SurveyDocumentFeedbackEvaluationGroupsExcelErrors, GetApiV1SurveyDocumentFeedbackEvaluationGroupsExcelExportUrlData, GetApiV1SurveyDocumentFeedbackEvaluationGroupsExcelExportUrlErrors, GetApiV1SurveyDocumentFeedbackEvaluationGroupsExcelExportUrlResponses, GetApiV1SurveyDocumentFeedbackEvaluationGroupsExcelResponses, GetApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupData, GetApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupErrors, GetApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupResponses, GetApiV1SurveyDocumentFeedbackEvaluationGroupsResponses, GetApiV1SurveyDocumentFeedbackEvaluationGroupsWordData, GetApiV1SurveyDocumentFeedbackEvaluationGroupsWordErrors, GetApiV1SurveyDocumentFeedbackEvaluationGroupsWordExportUrlData, GetApiV1SurveyDocumentFeedbackEvaluationGroupsWordExportUrlErrors, GetApiV1SurveyDocumentFeedbackEvaluationGroupsWordExportUrlResponses, GetApiV1SurveyDocumentFeedbackEvaluationGroupsWordResponses, GetApiV1SurveyDocumentFeedbackGroupsData, GetApiV1SurveyDocumentFeedbackGroupsErrors, GetApiV1SurveyDocumentFeedbackGroupsIdData, GetApiV1SurveyDocumentFeedbackGroupsIdResponses, GetApiV1SurveyDocumentFeedbackGroupsResponses, GetApiV1SurveyDocumentFeedbacksData, GetApiV1SurveyDocumentFeedbacksErrors, GetApiV1SurveyDocumentFeedbacksResponses, GetApiV1SurveyDocumentGroupsData, GetApiV1SurveyDocumentGroupsErrors, GetApiV1SurveyDocumentGroupsIdData, GetApiV1SurveyDocumentGroupsIdErrors, GetApiV1SurveyDocumentGroupsIdResponses, GetApiV1SurveyDocumentGroupsResponses, GetApiV1SurveyDocumentGroupTagsData, GetApiV1SurveyDocumentGroupTagsErrors, GetApiV1SurveyDocumentGroupTagsIdData, GetApiV1SurveyDocumentGroupTagsIdErrors, GetApiV1SurveyDocumentGroupTagsIdResponses, GetApiV1SurveyDocumentGroupTagsResponses, GetApiV1SurveyDocumentPageAreasData, GetApiV1SurveyDocumentPageAreasErrors, GetApiV1SurveyDocumentPageAreasLanguagesData, GetApiV1SurveyDocumentPageAreasLanguagesErrors, GetApiV1SurveyDocumentPageAreasLanguagesResponses, GetApiV1SurveyDocumentPageAreasResponses, GetApiV1SurveyDocumentQuestionsData, GetApiV1SurveyDocumentQuestionsErrors, GetApiV1SurveyDocumentQuestionsIdData, GetApiV1SurveyDocumentQuestionsIdErrors, GetApiV1SurveyDocumentQuestionsIdResponses, GetApiV1SurveyDocumentQuestionsResponses, GetApiV1SurveyDocumentsData, GetApiV1SurveyDocumentsErrors, GetApiV1SurveyDocumentsIdData, GetApiV1SurveyDocumentsIdErrors, GetApiV1SurveyDocumentsIdResponses, GetApiV1SurveyDocumentsResponses, GetApiV1SurveyDocumentsSurveyDocumentIdPdfData, GetApiV1SurveyDocumentsSurveyDocumentIdPdfErrors, GetApiV1SurveyDocumentsSurveyDocumentIdPdfResponses, GetApiV1SurveyDocumentsSurveyDocumentIdQuestionAnswersExcelData, GetApiV1SurveyDocumentsSurveyDocumentIdQuestionAnswersExcelErrors, GetApiV1SurveyDocumentsSurveyDocumentIdQuestionAnswersExcelExportUrlData, GetApiV1SurveyDocumentsSurveyDocumentIdQuestionAnswersExcelExportUrlErrors, GetApiV1SurveyDocumentsSurveyDocumentIdQuestionAnswersExcelExportUrlResponses, GetApiV1SurveyDocumentsSurveyDocumentIdQuestionAnswersExcelResponses, GetApiV1SurveyDocumentTagsData, GetApiV1SurveyDocumentTagsErrors, GetApiV1SurveyDocumentTagsIdData, GetApiV1SurveyDocumentTagsIdErrors, GetApiV1SurveyDocumentTagsIdResponses, GetApiV1SurveyDocumentTagsResponses, GetApiV1SurveyEmailTemplateAttachmentSurveyEmailTemplateAttachmentIdDownloadData, GetApiV1SurveyEmailTemplatesData, GetApiV1SurveyEmailTemplatesErrors, GetApiV1SurveyEmailTemplatesMailPreviewBodyData, GetApiV1SurveyEmailTemplatesMailPreviewBodyErrors, GetApiV1SurveyEmailTemplatesMailPreviewBodyResponses, GetApiV1SurveyEmailTemplatesMailPreviewData, GetApiV1SurveyEmailTemplatesMailPreviewErrors, GetApiV1SurveyEmailTemplatesMailPreviewResponses, GetApiV1SurveyEmailTemplatesResponses, GetApiV1SurveyEmailTemplatesSurveyEmailTemplateIdData, GetApiV1SurveyEmailTemplatesSurveyEmailTemplateIdErrors, GetApiV1SurveyEmailTemplatesSurveyEmailTemplateIdResponses, GetApiV1SurveyExportsData, GetApiV1SurveyExportsErrors, GetApiV1SurveyExportsIdData, GetApiV1SurveyExportsIdErrors, GetApiV1SurveyExportsIdResponses, GetApiV1SurveyExportsResponses, GetApiV1SurveyExportsSurveyExportIdDownloadUrlData, GetApiV1SurveyExportsSurveyExportIdDownloadUrlErrors, GetApiV1SurveyExportsSurveyExportIdDownloadUrlResponses, GetApiV1SurveyModuleAnswersData, GetApiV1SurveyModuleAnswersErrors, GetApiV1SurveyModuleAnswersExcelData, GetApiV1SurveyModuleAnswersExcelErrors, GetApiV1SurveyModuleAnswersExcelExportUrlData, GetApiV1SurveyModuleAnswersExcelExportUrlErrors, GetApiV1SurveyModuleAnswersExcelExportUrlResponses, GetApiV1SurveyModuleAnswersExcelResponses, GetApiV1SurveyModuleAnswersResponses, GetApiV1SurveyModuleQuestionsData, GetApiV1SurveyModuleQuestionsErrors, GetApiV1SurveyModuleQuestionsResponses, GetApiV1SurveyModuleQuestionsSurveyModuleQuestionIdResultsData, GetApiV1SurveyModuleQuestionsSurveyModuleQuestionIdResultsErrors, GetApiV1SurveyModuleQuestionsSurveyModuleQuestionIdResultsResponses, GetApiV1SurveysData, GetApiV1SurveysErrors, GetApiV1SurveysGeneralReportDownloadData, GetApiV1SurveysGeneralReportDownloadErrors, GetApiV1SurveysGeneralReportDownloadResponses, GetApiV1SurveysResponses, GetApiV1SurveysSurveyBySlugData, GetApiV1SurveysSurveyBySlugErrors, GetApiV1SurveysSurveyBySlugLogoData, GetApiV1SurveysSurveyBySlugLogoResponses, GetApiV1SurveysSurveyBySlugResponses, GetApiV1SurveysSurveyIdKeyFiguresData, GetApiV1SurveysSurveyIdKeyFiguresErrors, GetApiV1SurveysSurveyIdKeyFiguresResponses, GetApiV1SurveysSurveyIdStatsData, GetApiV1SurveysSurveyIdStatsErrors, GetApiV1SurveysSurveyIdStatsResponses, GetApiV1SurveysSurveyIdTagsData, GetApiV1SurveysSurveyIdTagsErrors, GetApiV1SurveysSurveyIdTagsResponses, GetApiV1SurveysSurveyIdUsersData, GetApiV1SurveysSurveyIdUsersErrors, GetApiV1SurveysSurveyIdUsersResponses, GetApiV1SurveyStagesData, GetApiV1SurveyStagesErrors, GetApiV1SurveyStagesIdData, GetApiV1SurveyStagesIdErrors, GetApiV1SurveyStagesIdResponses, GetApiV1SurveyStagesResponses, GetApiV1SurveyStagesSurveyStageIdParticipantGroupsParticipantGroupIdCheckSubmittingRightsData, GetApiV1SurveyStagesSurveyStageIdParticipantGroupsParticipantGroupIdCheckSubmittingRightsResponses, GetApiV1SurveyTagsData, GetApiV1SurveyTagsResponses, GetEmi5893Phase1GenerateTheFillableReadOnlyExceptFieldsWordFormForASurveyStageData, GetEmi5893Phase1GenerateTheFillableReadOnlyExceptFieldsWordFormForASurveyStageErrors, GetEmi5893Phase1GenerateTheFillableReadOnlyExceptFieldsWordFormForASurveyStageResponses, PostApiV1CommentsCommentIdApproveData, PostApiV1CommentsCommentIdApproveErrors, PostApiV1CommentsCommentIdApproveResponses, PostApiV1CommentsCommentIdUnapproveData, PostApiV1CommentsCommentIdUnapproveErrors, PostApiV1CommentsCommentIdUnapproveResponses, PostApiV1CommentsCommentIdVoteData, PostApiV1CommentsCommentIdVoteErrors, PostApiV1CommentsCommentIdVoteResponses, PostApiV1CommentsParentCommentIdCommentData, PostApiV1CommentsParentCommentIdCommentErrors, PostApiV1CommentsParentCommentIdCommentResponses, PostApiV1CreateAnonymousParticipantData, PostApiV1CreateAnonymousParticipantErrors, PostApiV1CreateAnonymousParticipantResponses, PostApiV1EvaluationGroupReactionFieldsData, PostApiV1EvaluationGroupReactionFieldsErrors, PostApiV1EvaluationGroupReactionFieldsResponses, PostApiV1EvaluationPageSettingsData, PostApiV1EvaluationPageSettingsErrors, PostApiV1EvaluationPageSettingsResponses, PostApiV1FeedbackTagsData, PostApiV1FeedbackTagsErrors, PostApiV1FeedbackTagsResponses, PostApiV1IdeaBoardEntriesBulkApproveData, PostApiV1IdeaBoardEntriesBulkApproveErrors, PostApiV1IdeaBoardEntriesBulkApproveResponses, PostApiV1IdeaBoardEntriesBulkTagData, PostApiV1IdeaBoardEntriesBulkTagErrors, PostApiV1IdeaBoardEntriesBulkTagResponses, PostApiV1IdeaBoardEntriesData, PostApiV1IdeaBoardEntriesErrors, PostApiV1IdeaBoardEntriesIdeaBoardEntryIdApproveData, PostApiV1IdeaBoardEntriesIdeaBoardEntryIdApproveErrors, PostApiV1IdeaBoardEntriesIdeaBoardEntryIdApproveResponses, PostApiV1IdeaBoardEntriesIdeaBoardEntryIdCommentData, PostApiV1IdeaBoardEntriesIdeaBoardEntryIdCommentErrors, PostApiV1IdeaBoardEntriesIdeaBoardEntryIdCommentResponses, PostApiV1IdeaBoardEntriesIdeaBoardEntryIdUnapproveData, PostApiV1IdeaBoardEntriesIdeaBoardEntryIdUnapproveErrors, PostApiV1IdeaBoardEntriesIdeaBoardEntryIdUnapproveResponses, PostApiV1IdeaBoardEntriesIdeaBoardEntryIdVoteData, PostApiV1IdeaBoardEntriesIdeaBoardEntryIdVoteErrors, PostApiV1IdeaBoardEntriesIdeaBoardEntryIdVoteResponses, PostApiV1IdeaBoardEntriesResponses, PostApiV1LocalesFlushData, PostApiV1LocalesFlushResponses, PostApiV1MessagingSendMessageData, PostApiV1MessagingSendMessageErrors, PostApiV1MessagingSendMessageResponses, PostApiV1MessagingSendTestMessageData, PostApiV1MessagingSendTestMessageErrors, PostApiV1MessagingSendTestMessageResponses, PostApiV1OauthLogoutData, PostApiV1OauthLogoutResponses, PostApiV1OauthOnboardingTokenData, PostApiV1OauthOnboardingTokenErrors, PostApiV1OauthOnboardingTokenResponses, PostApiV1OauthPasswordEmailData, PostApiV1OauthPasswordEmailErrors, PostApiV1OauthPasswordEmailResponses, PostApiV1OauthPasswordSetData, PostApiV1OauthPasswordSetResponses, PostApiV1OauthSecondFactorLoginData, PostApiV1OauthSecondFactorLoginErrors, PostApiV1OauthSecondFactorLoginResponses, PostApiV1OauthSendTwoFaTokenData, PostApiV1OauthSendTwoFaTokenErrors, PostApiV1OauthSendTwoFaTokenResponses, PostApiV1OauthTokenData, PostApiV1OauthTokenErrors, PostApiV1OauthTokenResponses, PostApiV1OauthTokenSsoLoginData, PostApiV1OauthTokenSsoLoginErrors, PostApiV1OauthTokenSsoLoginResponses, PostApiV1ParticipantGroupsData, PostApiV1ParticipantGroupsDeleteData, PostApiV1ParticipantGroupsDeleteErrors, PostApiV1ParticipantGroupsDeleteResponses, PostApiV1ParticipantGroupsErrors, PostApiV1ParticipantGroupsParticipantGroupIdUsersData, PostApiV1ParticipantGroupsParticipantGroupIdUsersErrors, PostApiV1ParticipantGroupsParticipantGroupIdUsersResponses, PostApiV1ParticipantGroupsResponses, PostApiV1ParticipantGroupTagsData, PostApiV1ParticipantGroupTagsErrors, PostApiV1ParticipantGroupTagsResponses, PostApiV1ParticipantImportFilesData, PostApiV1ParticipantImportFilesErrors, PostApiV1ParticipantImportFilesResponses, PostApiV1ParticipantsCheckCsvData, PostApiV1ParticipantsCheckCsvErrors, PostApiV1ParticipantsCheckCsvResponses, PostApiV1ParticipantsCsvData, PostApiV1ParticipantsCsvErrors, PostApiV1ParticipantsCsvResponses, PostApiV1ParticipantsData, PostApiV1ParticipantsErrors, PostApiV1ParticipantsGetOrCreateParticipantGroupForAdminData, PostApiV1ParticipantsGetOrCreateParticipantGroupForAdminErrors, PostApiV1ParticipantsGetOrCreateParticipantGroupForAdminResponses, PostApiV1ParticipantsImportFromTemplateData, PostApiV1ParticipantsImportFromTemplateErrors, PostApiV1ParticipantsImportFromTemplateResponses, PostApiV1ParticipantsRegisterData, PostApiV1ParticipantsRegisterErrors, PostApiV1ParticipantsRegisterResponses, PostApiV1ParticipantsResponses, PostApiV1ParticipantsValidateFirstLogonPublicStageFirstStepData, PostApiV1ParticipantsValidateFirstLogonPublicStageFirstStepErrors, PostApiV1ParticipantsValidateFirstLogonPublicStageFirstStepResponses, PostApiV1ParticipantsValidateRegistrationFirstStepData, PostApiV1ParticipantsValidateRegistrationFirstStepErrors, PostApiV1ParticipantsValidateRegistrationFirstStepResponses, PostApiV1PlatformFeedbacksData, PostApiV1PlatformFeedbacksErrors, PostApiV1PlatformFeedbacksResponses, PostApiV1SpaceAssetsData, PostApiV1SpaceAssetsErrors, PostApiV1SpaceAssetsResponses, PostApiV1SpaceEmailTemplatesData, PostApiV1SpaceEmailTemplatesErrors, PostApiV1SpaceEmailTemplatesResponses, PostApiV1SpacesData, PostApiV1SpacesErrors, PostApiV1SpacesResponses, PostApiV1SpacesSpaceIdAdminsData, PostApiV1SpacesSpaceIdAdminsErrors, PostApiV1SpacesSpaceIdAdminsResponses, PostApiV1SpaceUsersSpaceUserIdUnlockData, PostApiV1SpaceUsersSpaceUserIdUnlockErrors, PostApiV1SpaceUsersSpaceUserIdUnlockResponses, PostApiV1SpaceUsersUnionConflictedSpaceUsersAndLoginData, PostApiV1SpaceUsersUnionConflictedSpaceUsersAndLoginErrors, PostApiV1SpaceUsersUnionConflictedSpaceUsersAndLoginResponses, PostApiV1SupportRequestsData, PostApiV1SupportRequestsErrors, PostApiV1SupportRequestsResponses, PostApiV1SurveyCategoriesData, PostApiV1SurveyCategoriesErrors, PostApiV1SurveyCategoriesResponses, PostApiV1SurveyDocumentContentsCmsData, PostApiV1SurveyDocumentContentsCmsErrors, PostApiV1SurveyDocumentContentsCmsResponses, PostApiV1SurveyDocumentContentsData, PostApiV1SurveyDocumentContentsErrors, PostApiV1SurveyDocumentContentsImportData, PostApiV1SurveyDocumentContentsImportErrors, PostApiV1SurveyDocumentContentsImportResponses, PostApiV1SurveyDocumentContentsResponses, PostApiV1SurveyDocumentFeedbackEvaluationGroupReactionsData, PostApiV1SurveyDocumentFeedbackEvaluationGroupReactionsErrors, PostApiV1SurveyDocumentFeedbackEvaluationGroupReactionsResponses, PostApiV1SurveyDocumentFeedbackEvaluationGroupsData, PostApiV1SurveyDocumentFeedbackEvaluationGroupsErrors, PostApiV1SurveyDocumentFeedbackEvaluationGroupsImportData, PostApiV1SurveyDocumentFeedbackEvaluationGroupsImportErrors, PostApiV1SurveyDocumentFeedbackEvaluationGroupsImportResponses, PostApiV1SurveyDocumentFeedbackEvaluationGroupsResponses, PostApiV1SurveyDocumentFeedbackGroupsData, PostApiV1SurveyDocumentFeedbackGroupsErrors, PostApiV1SurveyDocumentFeedbackGroupsResponses, PostApiV1SurveyDocumentFeedbackGroupsWithFeedbackData, PostApiV1SurveyDocumentFeedbackGroupsWithFeedbackErrors, PostApiV1SurveyDocumentFeedbackGroupsWithFeedbackResponses, PostApiV1SurveyDocumentFeedbacksData, PostApiV1SurveyDocumentFeedbacksErrors, PostApiV1SurveyDocumentFeedbacksResponses, PostApiV1SurveyDocumentGroupsData, PostApiV1SurveyDocumentGroupsErrors, PostApiV1SurveyDocumentGroupsResponses, PostApiV1SurveyDocumentGroupTagsData, PostApiV1SurveyDocumentGroupTagsErrors, PostApiV1SurveyDocumentGroupTagsResponses, PostApiV1SurveyDocumentPageAreasCopyLanguageData, PostApiV1SurveyDocumentPageAreasCopyLanguageErrors, PostApiV1SurveyDocumentPageAreasCopyLanguageResponses, PostApiV1SurveyDocumentPageAreasData, PostApiV1SurveyDocumentPageAreasErrors, PostApiV1SurveyDocumentPageAreasResponses, PostApiV1SurveyDocumentPageAreasStoreMassData, PostApiV1SurveyDocumentPageAreasStoreMassErrors, PostApiV1SurveyDocumentPageAreasStoreMassResponses, PostApiV1SurveyDocumentQuestionAnswersMassData, PostApiV1SurveyDocumentQuestionAnswersMassErrors, PostApiV1SurveyDocumentQuestionAnswersMassResponses, PostApiV1SurveyDocumentQuestionsData, PostApiV1SurveyDocumentQuestionsErrors, PostApiV1SurveyDocumentQuestionsMassData, PostApiV1SurveyDocumentQuestionsMassErrors, PostApiV1SurveyDocumentQuestionsMassResponses, PostApiV1SurveyDocumentQuestionsResponses, PostApiV1SurveyDocumentsData, PostApiV1SurveyDocumentsErrors, PostApiV1SurveyDocumentsResponses, PostApiV1SurveyDocumentTagsData, PostApiV1SurveyDocumentTagsErrors, PostApiV1SurveyDocumentTagsResponses, PostApiV1SurveyEmailTemplatesData, PostApiV1SurveyEmailTemplatesErrors, PostApiV1SurveyEmailTemplatesResponses, PostApiV1SurveyEmailTemplatesSendTestData, PostApiV1SurveyEmailTemplatesSendTestErrors, PostApiV1SurveyEmailTemplatesSendTestResponses, PostApiV1SurveyEmailTemplatesSurveyEmailTemplateIdSendData, PostApiV1SurveyEmailTemplatesSurveyEmailTemplateIdSendErrors, PostApiV1SurveyEmailTemplatesSurveyEmailTemplateIdSendResponses, PostApiV1SurveyExportsData, PostApiV1SurveyExportsErrors, PostApiV1SurveyExportsResponses, PostApiV1SurveyModuleAnswersData, PostApiV1SurveyModuleAnswersErrors, PostApiV1SurveyModuleAnswersResponses, PostApiV1SurveyModuleQuestionsData, PostApiV1SurveyModuleQuestionsErrors, PostApiV1SurveyModuleQuestionsResponses, PostApiV1SurveysData, PostApiV1SurveysErrors, PostApiV1SurveysResponses, PostApiV1SurveysSurveyIdCopyData, PostApiV1SurveysSurveyIdCopyErrors, PostApiV1SurveysSurveyIdCopyResponses, PostApiV1SurveysSurveyIdDispatchSearchForSimilarEvaluationGroupsData, PostApiV1SurveysSurveyIdDispatchSearchForSimilarEvaluationGroupsErrors, PostApiV1SurveysSurveyIdDispatchSearchForSimilarEvaluationGroupsResponses, PostApiV1SurveysSurveyIdPublishSubmissionData, PostApiV1SurveysSurveyIdPublishSubmissionErrors, PostApiV1SurveysSurveyIdPublishSubmissionResponses, PostApiV1SurveysSurveyIdRevokeSubmitData, PostApiV1SurveysSurveyIdRevokeSubmitErrors, PostApiV1SurveysSurveyIdRevokeSubmitResponses, PostApiV1SurveysSurveyIdSendInvitationEmailData, PostApiV1SurveysSurveyIdSendInvitationEmailErrors, PostApiV1SurveysSurveyIdSendInvitationEmailResponses, PostApiV1SurveysSurveyIdSendParticipantReactionReportData, PostApiV1SurveysSurveyIdSendParticipantReactionReportErrors, PostApiV1SurveysSurveyIdSendParticipantReactionReportResponses, PostApiV1SurveysSurveyIdSendRecordingReminderData, PostApiV1SurveysSurveyIdSendRecordingReminderErrors, PostApiV1SurveysSurveyIdSendRecordingReminderResponses, PostApiV1SurveysSurveyIdSendSubmittingReminderData, PostApiV1SurveysSurveyIdSendSubmittingReminderErrors, PostApiV1SurveysSurveyIdSendSubmittingReminderResponses, PostApiV1SurveysSurveyIdSubmitData, PostApiV1SurveysSurveyIdSubmitErrors, PostApiV1SurveysSurveyIdSubmitResponses, PostApiV1SurveysSurveyIdUsersData, PostApiV1SurveysSurveyIdUsersErrors, PostApiV1SurveysSurveyIdUsersResponses, PostApiV1SurveyStagesData, PostApiV1SurveyStagesErrors, PostApiV1SurveyStagesResponses, PostApiV1SurveyStagesSurveyStageIdParticipantGroupsAttachData, PostApiV1SurveyStagesSurveyStageIdParticipantGroupsAttachErrors, PostApiV1SurveyStagesSurveyStageIdParticipantGroupsAttachResponses, PostApiV1SurveyStagesSurveyStageIdParticipantGroupsDetachData, PostApiV1SurveyStagesSurveyStageIdParticipantGroupsDetachErrors, PostApiV1SurveyStagesSurveyStageIdParticipantGroupsDetachResponses, PostApiV1TranslationsFlushData, PostApiV1TranslationsFlushResponses, PostChangeTeamAdminOfAParticipantGroupData, PostChangeTeamAdminOfAParticipantGroupErrors, PostChangeTeamAdminOfAParticipantGroupResponses, PostEmi5893Phase1ReadAnUploadedFilledWordFormBackAndCreateTheFeedbackItContainsData, PostEmi5893Phase1ReadAnUploadedFilledWordFormBackAndCreateTheFeedbackItContainsErrors, PostEmi5893Phase1ReadAnUploadedFilledWordFormBackAndCreateTheFeedbackItContainsResponses, PutApiV1CommentsIdData, PutApiV1CommentsIdErrors, PutApiV1CommentsIdResponses, PutApiV1EvaluationGroupReactionFieldsIdData, PutApiV1EvaluationGroupReactionFieldsIdErrors, PutApiV1EvaluationGroupReactionFieldsIdResponses, PutApiV1EvaluationGroupReactionFieldsSortData, PutApiV1EvaluationGroupReactionFieldsSortErrors, PutApiV1EvaluationGroupReactionFieldsSortResponses, PutApiV1EvaluationPageSettingsIdData, PutApiV1EvaluationPageSettingsIdErrors, PutApiV1EvaluationPageSettingsIdResponses, PutApiV1FeedbackTagsIdData, PutApiV1FeedbackTagsIdErrors, PutApiV1FeedbackTagsIdResponses, PutApiV1IdeaBoardEntriesIdData, PutApiV1IdeaBoardEntriesIdErrors, PutApiV1IdeaBoardEntriesIdResponses, PutApiV1OauthSendEmailVerificationLinkData, PutApiV1OauthSendEmailVerificationLinkErrors, PutApiV1OauthSendEmailVerificationLinkResponses, PutApiV1OauthSetup2FaData, PutApiV1OauthSetup2FaErrors, PutApiV1OauthSetup2FaResponses, PutApiV1OauthUserUserIdVerifyEmailData, PutApiV1OauthUserUserIdVerifyEmailErrors, PutApiV1OauthUserUserIdVerifyEmailResponses, PutApiV1OauthVerifyPhoneData, PutApiV1OauthVerifyPhoneErrors, PutApiV1OauthVerifyPhoneResponses, PutApiV1ParticipantGroupsParticipantGroupIdAssociateOfflineSubmissionPdfData, PutApiV1ParticipantGroupsParticipantGroupIdAssociateOfflineSubmissionPdfErrors, PutApiV1ParticipantGroupsParticipantGroupIdAssociateOfflineSubmissionPdfResponses, PutApiV1ParticipantGroupsParticipantGroupIdData, PutApiV1ParticipantGroupsParticipantGroupIdDisassociateOfflineSubmissionPdfData, PutApiV1ParticipantGroupsParticipantGroupIdDisassociateOfflineSubmissionPdfErrors, PutApiV1ParticipantGroupsParticipantGroupIdDisassociateOfflineSubmissionPdfResponses, PutApiV1ParticipantGroupsParticipantGroupIdErrors, PutApiV1ParticipantGroupsParticipantGroupIdResponses, PutApiV1ParticipantGroupsParticipantGroupIdSyncToStageData, PutApiV1ParticipantGroupsParticipantGroupIdSyncToStageErrors, PutApiV1ParticipantGroupsParticipantGroupIdSyncToStageResponses, PutApiV1ParticipantGroupsSyncTagsData, PutApiV1ParticipantGroupsSyncTagsErrors, PutApiV1ParticipantGroupsSyncTagsResponses, PutApiV1ParticipantGroupsUpdateStateData, PutApiV1ParticipantGroupsUpdateStateErrors, PutApiV1ParticipantGroupsUpdateStateResponses, PutApiV1ParticipantGroupTagsIdData, PutApiV1ParticipantGroupTagsIdErrors, PutApiV1ParticipantGroupTagsIdResponses, PutApiV1ParticipantImportFilesIdData, PutApiV1ParticipantImportFilesIdErrors, PutApiV1ParticipantImportFilesIdResponses, PutApiV1ParticipantsImportFromStageData, PutApiV1ParticipantsImportFromStageErrors, PutApiV1ParticipantsImportFromStageResponses, PutApiV1PlatformFeedbacksIdData, PutApiV1PlatformFeedbacksIdErrors, PutApiV1PlatformFeedbacksIdResponses, PutApiV1SpaceAssetsIdData, PutApiV1SpaceAssetsIdErrors, PutApiV1SpaceAssetsIdResponses, PutApiV1SpaceEmailTemplatesIdData, PutApiV1SpaceEmailTemplatesIdErrors, PutApiV1SpaceEmailTemplatesIdResponses, PutApiV1SpacesIdData, PutApiV1SpacesIdErrors, PutApiV1SpacesIdResponses, PutApiV1SpaceUsersSpaceUserIdData, PutApiV1SpaceUsersSpaceUserIdErrors, PutApiV1SpaceUsersSpaceUserIdResponses, PutApiV1SubmissionsIdData, PutApiV1SubmissionsIdErrors, PutApiV1SubmissionsIdResponses, PutApiV1SurveyCategoriesIdData, PutApiV1SurveyCategoriesIdErrors, PutApiV1SurveyCategoriesIdResponses, PutApiV1SurveyCategoriesSortData, PutApiV1SurveyCategoriesSortErrors, PutApiV1SurveyCategoriesSortResponses, PutApiV1SurveyDocumentContentsBulkData, PutApiV1SurveyDocumentContentsBulkErrors, PutApiV1SurveyDocumentContentsBulkResponses, PutApiV1SurveyDocumentContentsCmsIdData, PutApiV1SurveyDocumentContentsCmsIdErrors, PutApiV1SurveyDocumentContentsCmsIdResponses, PutApiV1SurveyDocumentContentsIdData, PutApiV1SurveyDocumentContentsIdErrors, PutApiV1SurveyDocumentContentsIdResponses, PutApiV1SurveyDocumentContentsSortData, PutApiV1SurveyDocumentContentsSortErrors, PutApiV1SurveyDocumentContentsSortResponses, PutApiV1SurveyDocumentFeedbackEvaluationGroupReactionsSortData, PutApiV1SurveyDocumentFeedbackEvaluationGroupReactionsSortErrors, PutApiV1SurveyDocumentFeedbackEvaluationGroupReactionsSortResponses, PutApiV1SurveyDocumentFeedbackEvaluationGroupsData, PutApiV1SurveyDocumentFeedbackEvaluationGroupsErrors, PutApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupDeclineSuggestionsData, PutApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupDeclineSuggestionsErrors, PutApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupDeclineSuggestionsResponses, PutApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupDetachSurveyDocumentFeedbackGroupsData, PutApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupDetachSurveyDocumentFeedbackGroupsErrors, PutApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupDetachSurveyDocumentFeedbackGroupsResponses, PutApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupMergeData, PutApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupMergeErrors, PutApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupMergeResponses, PutApiV1SurveyDocumentFeedbackEvaluationGroupsHideData, PutApiV1SurveyDocumentFeedbackEvaluationGroupsHideErrors, PutApiV1SurveyDocumentFeedbackEvaluationGroupsHideResponses, PutApiV1SurveyDocumentFeedbackEvaluationGroupsResponses, PutApiV1SurveyDocumentFeedbackEvaluationGroupsShowData, PutApiV1SurveyDocumentFeedbackEvaluationGroupsShowErrors, PutApiV1SurveyDocumentFeedbackEvaluationGroupsShowResponses, PutApiV1SurveyDocumentFeedbackEvaluationGroupsTagsData, PutApiV1SurveyDocumentFeedbackEvaluationGroupsTagsErrors, PutApiV1SurveyDocumentFeedbackEvaluationGroupsTagsResponses, PutApiV1SurveyDocumentFeedbackGroupsAffiliateData, PutApiV1SurveyDocumentFeedbackGroupsAffiliateErrors, PutApiV1SurveyDocumentFeedbackGroupsAffiliateResponses, PutApiV1SurveyDocumentFeedbackGroupsDisaffiliateData, PutApiV1SurveyDocumentFeedbackGroupsDisaffiliateErrors, PutApiV1SurveyDocumentFeedbackGroupsDisaffiliateResponses, PutApiV1SurveyDocumentFeedbackGroupsIdData, PutApiV1SurveyDocumentFeedbackGroupsIdErrors, PutApiV1SurveyDocumentFeedbackGroupsIdResponses, PutApiV1SurveyDocumentFeedbackGroupsSurveyDocumentFeedbackGroupIdSplitData, PutApiV1SurveyDocumentFeedbackGroupsSurveyDocumentFeedbackGroupIdSplitErrors, PutApiV1SurveyDocumentFeedbackGroupsSurveyDocumentFeedbackGroupIdSplitResponses, PutApiV1SurveyDocumentGroupsIdData, PutApiV1SurveyDocumentGroupsIdErrors, PutApiV1SurveyDocumentGroupsIdResponses, PutApiV1SurveyDocumentGroupsSortData, PutApiV1SurveyDocumentGroupsSortErrors, PutApiV1SurveyDocumentGroupsSortResponses, PutApiV1SurveyDocumentGroupTagsIdData, PutApiV1SurveyDocumentGroupTagsIdErrors, PutApiV1SurveyDocumentGroupTagsIdResponses, PutApiV1SurveyDocumentPageAreasIdData, PutApiV1SurveyDocumentPageAreasIdErrors, PutApiV1SurveyDocumentPageAreasIdResponses, PutApiV1SurveyDocumentQuestionsIdData, PutApiV1SurveyDocumentQuestionsIdErrors, PutApiV1SurveyDocumentQuestionsIdResponses, PutApiV1SurveyDocumentsIdData, PutApiV1SurveyDocumentsIdErrors, PutApiV1SurveyDocumentsIdResponses, PutApiV1SurveyDocumentsSortData, PutApiV1SurveyDocumentsSortErrors, PutApiV1SurveyDocumentsSortResponses, PutApiV1SurveyDocumentTagsIdData, PutApiV1SurveyDocumentTagsIdErrors, PutApiV1SurveyDocumentTagsIdResponses, PutApiV1SurveyEmailTemplatesIdData, PutApiV1SurveyEmailTemplatesIdErrors, PutApiV1SurveyEmailTemplatesIdResponses, PutApiV1SurveyModuleAnswersIdData, PutApiV1SurveyModuleAnswersIdErrors, PutApiV1SurveyModuleAnswersIdResponses, PutApiV1SurveyModuleQuestionsIdData, PutApiV1SurveyModuleQuestionsIdErrors, PutApiV1SurveyModuleQuestionsIdResponses, PutApiV1SurveysSurveyIdArchiveData, PutApiV1SurveysSurveyIdArchiveErrors, PutApiV1SurveysSurveyIdArchiveResponses, PutApiV1SurveysSurveyIdRemoveParticipantGroupsData, PutApiV1SurveysSurveyIdRemoveParticipantGroupsErrors, PutApiV1SurveysSurveyIdRemoveParticipantGroupsResponses, PutApiV1SurveysSurveyIdUnarchiveData, PutApiV1SurveysSurveyIdUnarchiveErrors, PutApiV1SurveysSurveyIdUnarchiveResponses, PutApiV1SurveyStagesIdData, PutApiV1SurveyStagesIdErrors, PutApiV1SurveyStagesIdResponses, PutApiV1UsersUserIdData, PutApiV1UsersUserIdErrors, PutApiV1UsersUserIdResponses, PutApiV1UsersUserIdVerifyEmailData, PutApiV1UsersUserIdVerifyEmailErrors, PutApiV1UsersUserIdVerifyEmailResponses, PutUpdateASurveyData, PutUpdateASurveyErrors, PutUpdateASurveyResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

export const postApiV1OauthToken = <ThrowOnError extends boolean = false>(options: Options<PostApiV1OauthTokenData, ThrowOnError>) => (options.client ?? client).post<PostApiV1OauthTokenResponses, PostApiV1OauthTokenErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/oauth/token',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postApiV1OauthTokenSsoLogin = <ThrowOnError extends boolean = false>(options: Options<PostApiV1OauthTokenSsoLoginData, ThrowOnError>) => (options.client ?? client).post<PostApiV1OauthTokenSsoLoginResponses, PostApiV1OauthTokenSsoLoginErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/oauth/token/sso-login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postApiV1OauthLogout = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1OauthLogoutData, ThrowOnError>) => (options?.client ?? client).post<PostApiV1OauthLogoutResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/oauth/logout',
    ...options
});

/**
 * /api/v1/oauth/password/email
 *
 * Send password reset link.
 */
export const postApiV1OauthPasswordEmail = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1OauthPasswordEmailData, ThrowOnError>) => (options?.client ?? client).post<PostApiV1OauthPasswordEmailResponses, PostApiV1OauthPasswordEmailErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/oauth/password/email',
    ...options
});

/**
 * /api/v1/oauth/password/set
 *
 * Reset password.
 */
export const postApiV1OauthPasswordSet = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1OauthPasswordSetData, ThrowOnError>) => (options?.client ?? client).post<PostApiV1OauthPasswordSetResponses, unknown, ThrowOnError>({
    responseType: 'text',
    url: '/api/v1/oauth/password/set',
    ...options
});

export const getApiV1OauthPasswordResetLeftTime = <ThrowOnError extends boolean = false>(options: Options<GetApiV1OauthPasswordResetLeftTimeData, ThrowOnError>) => (options.client ?? client).get<GetApiV1OauthPasswordResetLeftTimeResponses, GetApiV1OauthPasswordResetLeftTimeErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/oauth/password/reset-left-time',
    ...options
});

export const postApiV1OauthOnboardingToken = <ThrowOnError extends boolean = false>(options: Options<PostApiV1OauthOnboardingTokenData, ThrowOnError>) => (options.client ?? client).post<PostApiV1OauthOnboardingTokenResponses, PostApiV1OauthOnboardingTokenErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/oauth/onboarding-token',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const putApiV1OauthSendEmailVerificationLink = <ThrowOnError extends boolean = false>(options?: Options<PutApiV1OauthSendEmailVerificationLinkData, ThrowOnError>) => (options?.client ?? client).put<PutApiV1OauthSendEmailVerificationLinkResponses, PutApiV1OauthSendEmailVerificationLinkErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/oauth/send-email-verification-link',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const getApiV1SsoAzureRedirectUrl = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SsoAzureRedirectUrlData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SsoAzureRedirectUrlResponses, GetApiV1SsoAzureRedirectUrlErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/sso/azure/redirect-url',
    ...options
});

export const getApiV1SsoAzureCallback = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SsoAzureCallbackData, ThrowOnError>) => (options.client ?? client).get<unknown, GetApiV1SsoAzureCallbackErrors, ThrowOnError>({ url: '/api/v1/sso/azure/callback', ...options });

export const getApiV1SsoEZugRedirectUrl = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SsoEZugRedirectUrlData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SsoEZugRedirectUrlResponses, GetApiV1SsoEZugRedirectUrlErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/sso/e-zug/redirect-url',
    ...options
});

export const getApiV1SsoEZugCallback = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SsoEZugCallbackData, ThrowOnError>) => (options.client ?? client).get<unknown, GetApiV1SsoEZugCallbackErrors, ThrowOnError>({ url: '/api/v1/sso/e-zug/callback', ...options });

export const getApiV1SsoBsRedirectUrl = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SsoBsRedirectUrlData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SsoBsRedirectUrlResponses, GetApiV1SsoBsRedirectUrlErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/sso/bs/redirect-url',
    ...options
});

export const getApiV1SsoBsCallback = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SsoBsCallbackData, ThrowOnError>) => (options.client ?? client).get<unknown, GetApiV1SsoBsCallbackErrors, ThrowOnError>({ url: '/api/v1/sso/bs/callback', ...options });

export const putApiV1OauthVerifyPhone = <ThrowOnError extends boolean = false>(options: Options<PutApiV1OauthVerifyPhoneData, ThrowOnError>) => (options.client ?? client).put<PutApiV1OauthVerifyPhoneResponses, PutApiV1OauthVerifyPhoneErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/oauth/verify-phone',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postApiV1OauthSecondFactorLogin = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1OauthSecondFactorLoginData, ThrowOnError>) => (options?.client ?? client).post<PostApiV1OauthSecondFactorLoginResponses, PostApiV1OauthSecondFactorLoginErrors, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/oauth/second-factor-login',
    ...options
});

export const putApiV1OauthSetup2Fa = <ThrowOnError extends boolean = false>(options: Options<PutApiV1OauthSetup2FaData, ThrowOnError>) => (options.client ?? client).put<PutApiV1OauthSetup2FaResponses, PutApiV1OauthSetup2FaErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/oauth/setup-2fa',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postApiV1OauthSendTwoFaToken = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1OauthSendTwoFaTokenData, ThrowOnError>) => (options?.client ?? client).post<PostApiV1OauthSendTwoFaTokenResponses, PostApiV1OauthSendTwoFaTokenErrors, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/oauth/send-two-fa-token',
    ...options
});

export const getApiV1SingleSignOns = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SingleSignOnsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SingleSignOnsResponses, GetApiV1SingleSignOnsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/single-sign-ons',
    ...options
});

export const deleteApiV1SingleSignOnsId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SingleSignOnsIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SingleSignOnsIdResponses, DeleteApiV1SingleSignOnsIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/single-sign-ons/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * /api/v1/oauth/space-user/{spaceUser_id}/activate
 *
 * Activate space user by invitation link.
 */
export const getApiV1OauthSpaceUserSpaceUserIdActivate = <ThrowOnError extends boolean = false>(options: Options<GetApiV1OauthSpaceUserSpaceUserIdActivateData, ThrowOnError>) => (options.client ?? client).get<GetApiV1OauthSpaceUserSpaceUserIdActivateResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/oauth/space-user/{spaceUser_id}/activate',
    ...options
});

/**
 * /api/v1/oauth/user/{user_id}/activate
 *
 * Activate user by token.
 */
export const getApiV1OauthUserUserIdActivate = <ThrowOnError extends boolean = false>(options: Options<GetApiV1OauthUserUserIdActivateData, ThrowOnError>) => (options.client ?? client).get<GetApiV1OauthUserUserIdActivateResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/oauth/user/{user_id}/activate',
    ...options
});

export const putApiV1OauthUserUserIdVerifyEmail = <ThrowOnError extends boolean = false>(options: Options<PutApiV1OauthUserUserIdVerifyEmailData, ThrowOnError>) => (options.client ?? client).put<PutApiV1OauthUserUserIdVerifyEmailResponses, PutApiV1OauthUserUserIdVerifyEmailErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/oauth/user/{user_id}/verify-email',
    ...options
});

export const postApiV1ParticipantsValidateRegistrationFirstStep = <ThrowOnError extends boolean = false>(options: Options<PostApiV1ParticipantsValidateRegistrationFirstStepData, ThrowOnError>) => (options.client ?? client).post<PostApiV1ParticipantsValidateRegistrationFirstStepResponses, PostApiV1ParticipantsValidateRegistrationFirstStepErrors, ThrowOnError>({
    responseType: 'text',
    url: '/api/v1/participants/validate-registration-first-step',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postApiV1ParticipantsValidateFirstLogonPublicStageFirstStep = <ThrowOnError extends boolean = false>(options: Options<PostApiV1ParticipantsValidateFirstLogonPublicStageFirstStepData, ThrowOnError>) => (options.client ?? client).post<PostApiV1ParticipantsValidateFirstLogonPublicStageFirstStepResponses, PostApiV1ParticipantsValidateFirstLogonPublicStageFirstStepErrors, ThrowOnError>({
    responseType: 'text',
    url: '/api/v1/participants/validate-first-logon-public-stage-first-step',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * /api/v1/participants/register
 *
 * Register a participant.
 */
export const postApiV1ParticipantsRegister = <ThrowOnError extends boolean = false>(options: Options<PostApiV1ParticipantsRegisterData, ThrowOnError>) => (options.client ?? client).post<PostApiV1ParticipantsRegisterResponses, PostApiV1ParticipantsRegisterErrors, ThrowOnError>({
    responseType: 'text',
    url: '/api/v1/participants/register',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiV1SurveyDocumentContentsImportTemplate = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentContentsImportTemplateData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyDocumentContentsImportTemplateResponses, GetApiV1SurveyDocumentContentsImportTemplateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-contents/import-template',
    ...options
});

export const postApiV1SurveyDocumentContentsImport = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveyDocumentContentsImportData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SurveyDocumentContentsImportResponses, PostApiV1SurveyDocumentContentsImportErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-contents/import',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const putApiV1SurveyDocumentContentsSort = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SurveyDocumentContentsSortData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SurveyDocumentContentsSortResponses, PutApiV1SurveyDocumentContentsSortErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-contents/sort',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteApiV1SurveyDocumentContentsBulk = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SurveyDocumentContentsBulkData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SurveyDocumentContentsBulkResponses, DeleteApiV1SurveyDocumentContentsBulkErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-contents/bulk',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const putApiV1SurveyDocumentContentsBulk = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SurveyDocumentContentsBulkData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SurveyDocumentContentsBulkResponses, PutApiV1SurveyDocumentContentsBulkErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-contents/bulk',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * /api/v1/survey-document-contents
 *
 * List content blocks.
 */
export const getApiV1SurveyDocumentContents = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1SurveyDocumentContentsData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1SurveyDocumentContentsResponses, GetApiV1SurveyDocumentContentsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/survey-document-contents',
    ...options
});

/**
 * /api/v1/survey-document-contents
 *
 * Create a content block.
 */
export const postApiV1SurveyDocumentContents = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveyDocumentContentsData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SurveyDocumentContentsResponses, PostApiV1SurveyDocumentContentsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-contents',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * /api/v1/survey-document-contents/{id}
 *
 * Delete a content block.
 */
export const deleteApiV1SurveyDocumentContentsId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SurveyDocumentContentsIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SurveyDocumentContentsIdResponses, DeleteApiV1SurveyDocumentContentsIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-contents/{id}',
    ...options
});

/**
 * /api/v1/survey-document-contents/{id}
 *
 * Show a content block.
 */
export const getApiV1SurveyDocumentContentsId = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentContentsIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyDocumentContentsIdResponses, GetApiV1SurveyDocumentContentsIdErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/survey-document-contents/{id}',
    ...options
});

/**
 * /api/v1/survey-document-contents/{id}
 *
 * Update a content block.
 */
export const putApiV1SurveyDocumentContentsId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SurveyDocumentContentsIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SurveyDocumentContentsIdResponses, PutApiV1SurveyDocumentContentsIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-contents/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * /api/v1/survey-document-contents-cms
 *
 * List CMS content blocks.
 */
export const getApiV1SurveyDocumentContentsCms = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentContentsCmsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyDocumentContentsCmsResponses, GetApiV1SurveyDocumentContentsCmsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-contents-cms',
    ...options
});

/**
 * /api/v1/survey-document-contents-cms
 *
 * Create a CMS content block.
 */
export const postApiV1SurveyDocumentContentsCms = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveyDocumentContentsCmsData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SurveyDocumentContentsCmsResponses, PostApiV1SurveyDocumentContentsCmsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-contents-cms',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * /api/v1/survey-document-contents-cms/{id}
 *
 * Delete a CMS content block.
 */
export const deleteApiV1SurveyDocumentContentsCmsId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SurveyDocumentContentsCmsIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SurveyDocumentContentsCmsIdResponses, DeleteApiV1SurveyDocumentContentsCmsIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-contents-cms/{id}',
    ...options
});

/**
 * /api/v1/survey-document-contents-cms/{id}
 *
 * Show a CMS content block.
 */
export const getApiV1SurveyDocumentContentsCmsId = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentContentsCmsIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyDocumentContentsCmsIdResponses, GetApiV1SurveyDocumentContentsCmsIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-contents-cms/{id}',
    ...options
});

/**
 * /api/v1/survey-document-contents-cms/{id}
 *
 * Update a CMS content block.
 */
export const putApiV1SurveyDocumentContentsCmsId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SurveyDocumentContentsCmsIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SurveyDocumentContentsCmsIdResponses, PutApiV1SurveyDocumentContentsCmsIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-contents-cms/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * /api/v1/survey-document-content-attachments/{surveyDocumentContentAttachment_id}
 *
 * Delete a content attachment.
 */
export const deleteApiV1SurveyDocumentContentAttachmentsSurveyDocumentContentAttachmentId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SurveyDocumentContentAttachmentsSurveyDocumentContentAttachmentIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SurveyDocumentContentAttachmentsSurveyDocumentContentAttachmentIdResponses, DeleteApiV1SurveyDocumentContentAttachmentsSurveyDocumentContentAttachmentIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-content-attachments/{surveyDocumentContentAttachment_id}',
    ...options
});

export const getApiV1SurveyDocumentContentsCmsSurveyDocumentContentCmsDataIdDownload = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentContentsCmsSurveyDocumentContentCmsDataIdDownloadData, ThrowOnError>) => (options.client ?? client).get<unknown, GetApiV1SurveyDocumentContentsCmsSurveyDocumentContentCmsDataIdDownloadErrors, ThrowOnError>({ url: '/api/v1/survey-document-contents-cms/{surveyDocumentContentCmsData_id}/download', ...options });

export const postApiV1SurveyDocumentQuestionsMass = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveyDocumentQuestionsMassData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SurveyDocumentQuestionsMassResponses, PostApiV1SurveyDocumentQuestionsMassErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-questions/mass',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiV1SurveyDocumentQuestions = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentQuestionsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyDocumentQuestionsResponses, GetApiV1SurveyDocumentQuestionsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/survey-document-questions',
    ...options
});

/**
 * /api/v1/survey-document-questions
 *
 * Create a document question.
 */
export const postApiV1SurveyDocumentQuestions = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveyDocumentQuestionsData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SurveyDocumentQuestionsResponses, PostApiV1SurveyDocumentQuestionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-questions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * /api/v1/survey-document-questions/{id}
 *
 * Delete a document question.
 */
export const deleteApiV1SurveyDocumentQuestionsId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SurveyDocumentQuestionsIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SurveyDocumentQuestionsIdResponses, DeleteApiV1SurveyDocumentQuestionsIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-questions/{id}',
    ...options
});

/**
 * /api/v1/survey-document-questions/{id}
 *
 * Show a document question.
 */
export const getApiV1SurveyDocumentQuestionsId = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentQuestionsIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyDocumentQuestionsIdResponses, GetApiV1SurveyDocumentQuestionsIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-questions/{id}',
    ...options
});

/**
 * /api/v1/survey-document-questions/{id}
 *
 * Update a document question.
 */
export const putApiV1SurveyDocumentQuestionsId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SurveyDocumentQuestionsIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SurveyDocumentQuestionsIdResponses, PutApiV1SurveyDocumentQuestionsIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-questions/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postApiV1SurveyDocumentQuestionAnswersMass = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveyDocumentQuestionAnswersMassData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SurveyDocumentQuestionAnswersMassResponses, PostApiV1SurveyDocumentQuestionAnswersMassErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-question-answers/mass',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postApiV1SurveyEmailTemplatesSendTest = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveyEmailTemplatesSendTestData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SurveyEmailTemplatesSendTestResponses, PostApiV1SurveyEmailTemplatesSendTestErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-email-templates/send-test',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiV1SurveyEmailTemplatesMailPreview = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyEmailTemplatesMailPreviewData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyEmailTemplatesMailPreviewResponses, GetApiV1SurveyEmailTemplatesMailPreviewErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-email-templates/mail-preview',
    ...options
});

export const getApiV1SurveyEmailTemplates = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyEmailTemplatesData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyEmailTemplatesResponses, GetApiV1SurveyEmailTemplatesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-email-templates',
    ...options
});

export const postApiV1SurveyEmailTemplates = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveyEmailTemplatesData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SurveyEmailTemplatesResponses, PostApiV1SurveyEmailTemplatesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-email-templates',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteApiV1SurveyEmailTemplatesId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SurveyEmailTemplatesIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SurveyEmailTemplatesIdResponses, DeleteApiV1SurveyEmailTemplatesIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-email-templates/{id}',
    ...options
});

export const putApiV1SurveyEmailTemplatesId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SurveyEmailTemplatesIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SurveyEmailTemplatesIdResponses, PutApiV1SurveyEmailTemplatesIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-email-templates/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiV1SurveyEmailTemplatesSurveyEmailTemplateId = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyEmailTemplatesSurveyEmailTemplateIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyEmailTemplatesSurveyEmailTemplateIdResponses, GetApiV1SurveyEmailTemplatesSurveyEmailTemplateIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-email-templates/{surveyEmailTemplate_id}',
    ...options
});

export const deleteApiV1SurveyEmailTemplateAttachmentSurveyEmailTemplateAttachmentId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SurveyEmailTemplateAttachmentSurveyEmailTemplateAttachmentIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SurveyEmailTemplateAttachmentSurveyEmailTemplateAttachmentIdResponses, DeleteApiV1SurveyEmailTemplateAttachmentSurveyEmailTemplateAttachmentIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-email-template-attachment/{surveyEmailTemplateAttachment_id}',
    ...options
});

export const postApiV1SurveyEmailTemplatesSurveyEmailTemplateIdSend = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveyEmailTemplatesSurveyEmailTemplateIdSendData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SurveyEmailTemplatesSurveyEmailTemplateIdSendResponses, PostApiV1SurveyEmailTemplatesSurveyEmailTemplateIdSendErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-email-templates/{surveyEmailTemplate_id}/send',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiV1SurveyEmailTemplatesMailPreviewBody = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyEmailTemplatesMailPreviewBodyData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyEmailTemplatesMailPreviewBodyResponses, GetApiV1SurveyEmailTemplatesMailPreviewBodyErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-email-templates/mail-preview-body',
    ...options
});

export const getApiV1SurveyEmailTemplateAttachmentSurveyEmailTemplateAttachmentIdDownload = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyEmailTemplateAttachmentSurveyEmailTemplateAttachmentIdDownloadData, ThrowOnError>) => (options.client ?? client).get<unknown, unknown, ThrowOnError>({ url: '/api/v1/survey-email-template-attachment/{surveyEmailTemplateAttachment_id}/download', ...options });

export const getApiV1SpaceEmailTemplates = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1SpaceEmailTemplatesData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1SpaceEmailTemplatesResponses, GetApiV1SpaceEmailTemplatesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/space-email-templates',
    ...options
});

export const postApiV1SpaceEmailTemplates = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SpaceEmailTemplatesData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SpaceEmailTemplatesResponses, PostApiV1SpaceEmailTemplatesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/space-email-templates',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteApiV1SpaceEmailTemplatesId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SpaceEmailTemplatesIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SpaceEmailTemplatesIdResponses, DeleteApiV1SpaceEmailTemplatesIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/space-email-templates/{id}',
    ...options
});

export const getApiV1SpaceEmailTemplatesId = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SpaceEmailTemplatesIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SpaceEmailTemplatesIdResponses, GetApiV1SpaceEmailTemplatesIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/space-email-templates/{id}',
    ...options
});

export const putApiV1SpaceEmailTemplatesId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SpaceEmailTemplatesIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SpaceEmailTemplatesIdResponses, PutApiV1SpaceEmailTemplatesIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/space-email-templates/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postApiV1CreateAnonymousParticipant = <ThrowOnError extends boolean = false>(options: Options<PostApiV1CreateAnonymousParticipantData, ThrowOnError>) => (options.client ?? client).post<PostApiV1CreateAnonymousParticipantResponses, PostApiV1CreateAnonymousParticipantErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/create-anonymous-participant',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * EMI-5893 (Phase 1): generate the fillable, read-only-except-fields Word form for a survey stage.
 *
 * A member of the participant group, or a survey/space admin, may generate it (ParticipantGroupPolicy::view).
 */
export const getEmi5893Phase1GenerateTheFillableReadOnlyExceptFieldsWordFormForASurveyStage = <ThrowOnError extends boolean = false>(options: Options<GetEmi5893Phase1GenerateTheFillableReadOnlyExceptFieldsWordFormForASurveyStageData, ThrowOnError>) => (options.client ?? client).get<GetEmi5893Phase1GenerateTheFillableReadOnlyExceptFieldsWordFormForASurveyStageResponses, GetEmi5893Phase1GenerateTheFillableReadOnlyExceptFieldsWordFormForASurveyStageErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-stages/{surveyStage_id}/participant-groups/{participantGroup_id}/word-form',
    ...options
});

/**
 * EMI-5893 (Phase 1): read an uploaded, filled Word form back and create the feedback it contains.
 */
export const postEmi5893Phase1ReadAnUploadedFilledWordFormBackAndCreateTheFeedbackItContains = <ThrowOnError extends boolean = false>(options: Options<PostEmi5893Phase1ReadAnUploadedFilledWordFormBackAndCreateTheFeedbackItContainsData, ThrowOnError>) => (options.client ?? client).post<PostEmi5893Phase1ReadAnUploadedFilledWordFormBackAndCreateTheFeedbackItContainsResponses, PostEmi5893Phase1ReadAnUploadedFilledWordFormBackAndCreateTheFeedbackItContainsErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-stages/{surveyStage_id}/participant-groups/{participantGroup_id}/word-form',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

export const getApiV1SurveyDocumentTags = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentTagsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyDocumentTagsResponses, GetApiV1SurveyDocumentTagsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/survey-document-tags',
    ...options
});

export const postApiV1SurveyDocumentTags = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveyDocumentTagsData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SurveyDocumentTagsResponses, PostApiV1SurveyDocumentTagsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-tags',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteApiV1SurveyDocumentTagsId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SurveyDocumentTagsIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SurveyDocumentTagsIdResponses, DeleteApiV1SurveyDocumentTagsIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-tags/{id}',
    ...options
});

export const getApiV1SurveyDocumentTagsId = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentTagsIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyDocumentTagsIdResponses, GetApiV1SurveyDocumentTagsIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-tags/{id}',
    ...options
});

export const putApiV1SurveyDocumentTagsId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SurveyDocumentTagsIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SurveyDocumentTagsIdResponses, PutApiV1SurveyDocumentTagsIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-tags/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * /api/v1/survey-document-feedback-evaluation-groups/{feedback_evaluation_group}/merge
 *
 * Merge feedback groups into an evaluation group.
 */
export const putApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupMerge = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupMergeData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupMergeResponses, PutApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupMergeErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-evaluation-groups/{feedback_evaluation_group}/merge',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const putApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupDetachSurveyDocumentFeedbackGroups = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupDetachSurveyDocumentFeedbackGroupsData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupDetachSurveyDocumentFeedbackGroupsResponses, PutApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupDetachSurveyDocumentFeedbackGroupsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-evaluation-groups/{feedback_evaluation_group}/detach-survey-document-feedback-groups',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * /api/v1/survey-document-feedback-evaluation-groups/{feedback_evaluation_group}/decline-suggestions
 *
 * Decline suggested feedback groups.
 */
export const putApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupDeclineSuggestions = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupDeclineSuggestionsData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupDeclineSuggestionsResponses, PutApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupDeclineSuggestionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-evaluation-groups/{feedback_evaluation_group}/decline-suggestions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const putApiV1SurveyDocumentFeedbackEvaluationGroupsTags = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SurveyDocumentFeedbackEvaluationGroupsTagsData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SurveyDocumentFeedbackEvaluationGroupsTagsResponses, PutApiV1SurveyDocumentFeedbackEvaluationGroupsTagsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-evaluation-groups/tags',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const putApiV1SurveyDocumentFeedbackEvaluationGroupsHide = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SurveyDocumentFeedbackEvaluationGroupsHideData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SurveyDocumentFeedbackEvaluationGroupsHideResponses, PutApiV1SurveyDocumentFeedbackEvaluationGroupsHideErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-evaluation-groups/hide',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const putApiV1SurveyDocumentFeedbackEvaluationGroupsShow = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SurveyDocumentFeedbackEvaluationGroupsShowData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SurveyDocumentFeedbackEvaluationGroupsShowResponses, PutApiV1SurveyDocumentFeedbackEvaluationGroupsShowErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-evaluation-groups/show',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiV1SurveyDocumentFeedbackEvaluationGroupsWordExportUrl = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentFeedbackEvaluationGroupsWordExportUrlData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyDocumentFeedbackEvaluationGroupsWordExportUrlResponses, GetApiV1SurveyDocumentFeedbackEvaluationGroupsWordExportUrlErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-evaluation-groups/word-export-url',
    ...options
});

/**
 * /api/v1/survey-document-feedback-evaluation-groups
 *
 * List feedback evaluation groups.
 */
export const getApiV1SurveyDocumentFeedbackEvaluationGroups = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentFeedbackEvaluationGroupsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyDocumentFeedbackEvaluationGroupsResponses, GetApiV1SurveyDocumentFeedbackEvaluationGroupsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-evaluation-groups',
    ...options
});

export const postApiV1SurveyDocumentFeedbackEvaluationGroups = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveyDocumentFeedbackEvaluationGroupsData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SurveyDocumentFeedbackEvaluationGroupsResponses, PostApiV1SurveyDocumentFeedbackEvaluationGroupsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-evaluation-groups',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const putApiV1SurveyDocumentFeedbackEvaluationGroups = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SurveyDocumentFeedbackEvaluationGroupsData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SurveyDocumentFeedbackEvaluationGroupsResponses, PutApiV1SurveyDocumentFeedbackEvaluationGroupsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-evaluation-groups',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiV1SurveyDocumentFeedbackEvaluationGroupsExcelExportUrl = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentFeedbackEvaluationGroupsExcelExportUrlData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyDocumentFeedbackEvaluationGroupsExcelExportUrlResponses, GetApiV1SurveyDocumentFeedbackEvaluationGroupsExcelExportUrlErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-evaluation-groups/excel-export-url',
    ...options
});

export const postApiV1SurveyDocumentFeedbackEvaluationGroupsImport = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveyDocumentFeedbackEvaluationGroupsImportData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SurveyDocumentFeedbackEvaluationGroupsImportResponses, PostApiV1SurveyDocumentFeedbackEvaluationGroupsImportErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-evaluation-groups/import',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroup = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupResponses, DeleteApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupErrors, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-evaluation-groups/{feedback_evaluation_group}',
    ...options
});

export const getApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroup = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupResponses, GetApiV1SurveyDocumentFeedbackEvaluationGroupsFeedbackEvaluationGroupErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-evaluation-groups/{feedback_evaluation_group}',
    ...options
});

export const putApiV1SurveyDocumentFeedbackEvaluationGroupReactionsSort = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SurveyDocumentFeedbackEvaluationGroupReactionsSortData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SurveyDocumentFeedbackEvaluationGroupReactionsSortResponses, PutApiV1SurveyDocumentFeedbackEvaluationGroupReactionsSortErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-evaluation-group-reactions/sort',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiV1SurveyDocumentFeedbackEvaluationGroupReactions = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentFeedbackEvaluationGroupReactionsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyDocumentFeedbackEvaluationGroupReactionsResponses, GetApiV1SurveyDocumentFeedbackEvaluationGroupReactionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-evaluation-group-reactions',
    ...options
});

export const postApiV1SurveyDocumentFeedbackEvaluationGroupReactions = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveyDocumentFeedbackEvaluationGroupReactionsData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SurveyDocumentFeedbackEvaluationGroupReactionsResponses, PostApiV1SurveyDocumentFeedbackEvaluationGroupReactionsErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-evaluation-group-reactions',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

export const deleteApiV1SurveyDocumentFeedbackEvaluationGroupReactionsEvaluationGroupReactionId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SurveyDocumentFeedbackEvaluationGroupReactionsEvaluationGroupReactionIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SurveyDocumentFeedbackEvaluationGroupReactionsEvaluationGroupReactionIdResponses, DeleteApiV1SurveyDocumentFeedbackEvaluationGroupReactionsEvaluationGroupReactionIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-evaluation-group-reactions/{evaluation_group_reaction_id}',
    ...options
});

export const putApiV1EvaluationGroupReactionFieldsSort = <ThrowOnError extends boolean = false>(options: Options<PutApiV1EvaluationGroupReactionFieldsSortData, ThrowOnError>) => (options.client ?? client).put<PutApiV1EvaluationGroupReactionFieldsSortResponses, PutApiV1EvaluationGroupReactionFieldsSortErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/evaluation-group-reaction-fields/sort',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiV1EvaluationGroupReactionFields = <ThrowOnError extends boolean = false>(options: Options<GetApiV1EvaluationGroupReactionFieldsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1EvaluationGroupReactionFieldsResponses, GetApiV1EvaluationGroupReactionFieldsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/evaluation-group-reaction-fields',
    ...options
});

export const postApiV1EvaluationGroupReactionFields = <ThrowOnError extends boolean = false>(options: Options<PostApiV1EvaluationGroupReactionFieldsData, ThrowOnError>) => (options.client ?? client).post<PostApiV1EvaluationGroupReactionFieldsResponses, PostApiV1EvaluationGroupReactionFieldsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/evaluation-group-reaction-fields',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteApiV1EvaluationGroupReactionFieldsId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1EvaluationGroupReactionFieldsIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1EvaluationGroupReactionFieldsIdResponses, DeleteApiV1EvaluationGroupReactionFieldsIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/evaluation-group-reaction-fields/{id}',
    ...options
});

export const getApiV1EvaluationGroupReactionFieldsId = <ThrowOnError extends boolean = false>(options: Options<GetApiV1EvaluationGroupReactionFieldsIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1EvaluationGroupReactionFieldsIdResponses, GetApiV1EvaluationGroupReactionFieldsIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/evaluation-group-reaction-fields/{id}',
    ...options
});

export const putApiV1EvaluationGroupReactionFieldsId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1EvaluationGroupReactionFieldsIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1EvaluationGroupReactionFieldsIdResponses, PutApiV1EvaluationGroupReactionFieldsIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/evaluation-group-reaction-fields/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiV1SurveyDocumentFeedbackEvaluationGroupsWord = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentFeedbackEvaluationGroupsWordData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyDocumentFeedbackEvaluationGroupsWordResponses, GetApiV1SurveyDocumentFeedbackEvaluationGroupsWordErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-evaluation-groups/word',
    ...options
});

export const getApiV1SurveyDocumentFeedbackEvaluationGroupsExcel = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentFeedbackEvaluationGroupsExcelData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyDocumentFeedbackEvaluationGroupsExcelResponses, GetApiV1SurveyDocumentFeedbackEvaluationGroupsExcelErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-evaluation-groups/excel',
    ...options
});

export const putApiV1SurveyDocumentFeedbackGroupsSurveyDocumentFeedbackGroupIdSplit = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SurveyDocumentFeedbackGroupsSurveyDocumentFeedbackGroupIdSplitData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SurveyDocumentFeedbackGroupsSurveyDocumentFeedbackGroupIdSplitResponses, PutApiV1SurveyDocumentFeedbackGroupsSurveyDocumentFeedbackGroupIdSplitErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-groups/{surveyDocumentFeedbackGroup_id}/split',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const putApiV1SurveyDocumentFeedbackGroupsAffiliate = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SurveyDocumentFeedbackGroupsAffiliateData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SurveyDocumentFeedbackGroupsAffiliateResponses, PutApiV1SurveyDocumentFeedbackGroupsAffiliateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-groups/affiliate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const putApiV1SurveyDocumentFeedbackGroupsDisaffiliate = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SurveyDocumentFeedbackGroupsDisaffiliateData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SurveyDocumentFeedbackGroupsDisaffiliateResponses, PutApiV1SurveyDocumentFeedbackGroupsDisaffiliateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-groups/disaffiliate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * /api/v1/survey-document-feedback-groups/with-feedback
 *
 * Create a feedback group and its first feedback in a single call. Combines the legacy two-step flow (POST /survey-document-feedback-groups followed by POST /survey-document-feedbacks)
 */
export const postApiV1SurveyDocumentFeedbackGroupsWithFeedback = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveyDocumentFeedbackGroupsWithFeedbackData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SurveyDocumentFeedbackGroupsWithFeedbackResponses, PostApiV1SurveyDocumentFeedbackGroupsWithFeedbackErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-groups/with-feedback',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

export const getApiV1SurveyDocumentFeedbackGroups = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentFeedbackGroupsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyDocumentFeedbackGroupsResponses, GetApiV1SurveyDocumentFeedbackGroupsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/survey-document-feedback-groups',
    ...options
});

/**
 * /api/v1/survey-document-feedback-groups
 *
 * Create a feedback group.
 */
export const postApiV1SurveyDocumentFeedbackGroups = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveyDocumentFeedbackGroupsData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SurveyDocumentFeedbackGroupsResponses, PostApiV1SurveyDocumentFeedbackGroupsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-groups',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteApiV1SurveyDocumentFeedbackGroupsId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SurveyDocumentFeedbackGroupsIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SurveyDocumentFeedbackGroupsIdResponses, DeleteApiV1SurveyDocumentFeedbackGroupsIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-groups/{id}',
    ...options
});

export const getApiV1SurveyDocumentFeedbackGroupsId = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentFeedbackGroupsIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyDocumentFeedbackGroupsIdResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-groups/{id}',
    ...options
});

export const putApiV1SurveyDocumentFeedbackGroupsId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SurveyDocumentFeedbackGroupsIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SurveyDocumentFeedbackGroupsIdResponses, PutApiV1SurveyDocumentFeedbackGroupsIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedback-groups/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * /api/v1/survey-document-feedbacks
 *
 * List feedbacks for a feedback group.
 */
export const getApiV1SurveyDocumentFeedbacks = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentFeedbacksData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyDocumentFeedbacksResponses, GetApiV1SurveyDocumentFeedbacksErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedbacks',
    ...options
});

/**
 * /api/v1/survey-document-feedbacks
 *
 * Create a new feedback.
 */
export const postApiV1SurveyDocumentFeedbacks = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveyDocumentFeedbacksData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SurveyDocumentFeedbacksResponses, PostApiV1SurveyDocumentFeedbacksErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedbacks',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteApiV1SurveyDocumentFeedbacksId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SurveyDocumentFeedbacksIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SurveyDocumentFeedbacksIdResponses, DeleteApiV1SurveyDocumentFeedbacksIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-feedbacks/{id}',
    ...options
});

export const getApiV1FeedbackTags = <ThrowOnError extends boolean = false>(options: Options<GetApiV1FeedbackTagsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1FeedbackTagsResponses, GetApiV1FeedbackTagsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/feedback-tags',
    ...options
});

export const postApiV1FeedbackTags = <ThrowOnError extends boolean = false>(options: Options<PostApiV1FeedbackTagsData, ThrowOnError>) => (options.client ?? client).post<PostApiV1FeedbackTagsResponses, PostApiV1FeedbackTagsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/feedback-tags',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteApiV1FeedbackTagsId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1FeedbackTagsIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1FeedbackTagsIdResponses, DeleteApiV1FeedbackTagsIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/feedback-tags/{id}',
    ...options
});

export const getApiV1FeedbackTagsId = <ThrowOnError extends boolean = false>(options: Options<GetApiV1FeedbackTagsIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1FeedbackTagsIdResponses, GetApiV1FeedbackTagsIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/feedback-tags/{id}',
    ...options
});

export const putApiV1FeedbackTagsId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1FeedbackTagsIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1FeedbackTagsIdResponses, PutApiV1FeedbackTagsIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/feedback-tags/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiV1HealthCheck = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1HealthCheckData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1HealthCheckResponses, unknown, ThrowOnError>({
    responseType: 'text',
    url: '/api/v1/health-check',
    ...options
});

export const postApiV1IdeaBoardEntriesBulkApprove = <ThrowOnError extends boolean = false>(options: Options<PostApiV1IdeaBoardEntriesBulkApproveData, ThrowOnError>) => (options.client ?? client).post<PostApiV1IdeaBoardEntriesBulkApproveResponses, PostApiV1IdeaBoardEntriesBulkApproveErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idea-board-entries/bulk-approve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postApiV1IdeaBoardEntriesBulkTag = <ThrowOnError extends boolean = false>(options: Options<PostApiV1IdeaBoardEntriesBulkTagData, ThrowOnError>) => (options.client ?? client).post<PostApiV1IdeaBoardEntriesBulkTagResponses, PostApiV1IdeaBoardEntriesBulkTagErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idea-board-entries/bulk-tag',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteApiV1IdeaBoardEntriesBulkDestroy = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1IdeaBoardEntriesBulkDestroyData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1IdeaBoardEntriesBulkDestroyResponses, DeleteApiV1IdeaBoardEntriesBulkDestroyErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idea-board-entries/bulk-destroy',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * /api/v1/idea-board-entries
 *
 * List idea board entries.
 */
export const getApiV1IdeaBoardEntries = <ThrowOnError extends boolean = false>(options: Options<GetApiV1IdeaBoardEntriesData, ThrowOnError>) => (options.client ?? client).get<GetApiV1IdeaBoardEntriesResponses, GetApiV1IdeaBoardEntriesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/idea-board-entries',
    ...options
});

/**
 * /api/v1/idea-board-entries
 *
 * Create an idea board entry.
 */
export const postApiV1IdeaBoardEntries = <ThrowOnError extends boolean = false>(options: Options<PostApiV1IdeaBoardEntriesData, ThrowOnError>) => (options.client ?? client).post<PostApiV1IdeaBoardEntriesResponses, PostApiV1IdeaBoardEntriesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idea-board-entries',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * /api/v1/idea-board-entries/{id}
 *
 * Delete an idea board entry.
 */
export const deleteApiV1IdeaBoardEntriesId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1IdeaBoardEntriesIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1IdeaBoardEntriesIdResponses, DeleteApiV1IdeaBoardEntriesIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idea-board-entries/{id}',
    ...options
});

/**
 * /api/v1/idea-board-entries/{id}
 *
 * Show an idea board entry.
 */
export const getApiV1IdeaBoardEntriesId = <ThrowOnError extends boolean = false>(options: Options<GetApiV1IdeaBoardEntriesIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1IdeaBoardEntriesIdResponses, GetApiV1IdeaBoardEntriesIdErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/idea-board-entries/{id}',
    ...options
});

/**
 * /api/v1/idea-board-entries/{id}
 *
 * Update an idea board entry.
 */
export const putApiV1IdeaBoardEntriesId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1IdeaBoardEntriesIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1IdeaBoardEntriesIdResponses, PutApiV1IdeaBoardEntriesIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idea-board-entries/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiV1IdeaBoardEntriesExcelExportUrl = <ThrowOnError extends boolean = false>(options: Options<GetApiV1IdeaBoardEntriesExcelExportUrlData, ThrowOnError>) => (options.client ?? client).get<GetApiV1IdeaBoardEntriesExcelExportUrlResponses, GetApiV1IdeaBoardEntriesExcelExportUrlErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idea-board-entries/excel-export-url',
    ...options
});

export const postApiV1IdeaBoardEntriesIdeaBoardEntryIdVote = <ThrowOnError extends boolean = false>(options: Options<PostApiV1IdeaBoardEntriesIdeaBoardEntryIdVoteData, ThrowOnError>) => (options.client ?? client).post<PostApiV1IdeaBoardEntriesIdeaBoardEntryIdVoteResponses, PostApiV1IdeaBoardEntriesIdeaBoardEntryIdVoteErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idea-board-entries/{idea_board_entry_id}/vote',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postApiV1IdeaBoardEntriesIdeaBoardEntryIdComment = <ThrowOnError extends boolean = false>(options: Options<PostApiV1IdeaBoardEntriesIdeaBoardEntryIdCommentData, ThrowOnError>) => (options.client ?? client).post<PostApiV1IdeaBoardEntriesIdeaBoardEntryIdCommentResponses, PostApiV1IdeaBoardEntriesIdeaBoardEntryIdCommentErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idea-board-entries/{idea_board_entry_id}/comment',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postApiV1IdeaBoardEntriesIdeaBoardEntryIdApprove = <ThrowOnError extends boolean = false>(options: Options<PostApiV1IdeaBoardEntriesIdeaBoardEntryIdApproveData, ThrowOnError>) => (options.client ?? client).post<PostApiV1IdeaBoardEntriesIdeaBoardEntryIdApproveResponses, PostApiV1IdeaBoardEntriesIdeaBoardEntryIdApproveErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idea-board-entries/{idea_board_entry_id}/approve',
    ...options
});

export const postApiV1IdeaBoardEntriesIdeaBoardEntryIdUnapprove = <ThrowOnError extends boolean = false>(options: Options<PostApiV1IdeaBoardEntriesIdeaBoardEntryIdUnapproveData, ThrowOnError>) => (options.client ?? client).post<PostApiV1IdeaBoardEntriesIdeaBoardEntryIdUnapproveResponses, PostApiV1IdeaBoardEntriesIdeaBoardEntryIdUnapproveErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idea-board-entries/{idea_board_entry_id}/unapprove',
    ...options
});

export const deleteApiV1CommentsId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1CommentsIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1CommentsIdResponses, DeleteApiV1CommentsIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/comments/{id}',
    ...options
});

export const getApiV1CommentsId = <ThrowOnError extends boolean = false>(options: Options<GetApiV1CommentsIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1CommentsIdResponses, GetApiV1CommentsIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/comments/{id}',
    ...options
});

export const putApiV1CommentsId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1CommentsIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1CommentsIdResponses, PutApiV1CommentsIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/comments/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postApiV1CommentsCommentIdVote = <ThrowOnError extends boolean = false>(options: Options<PostApiV1CommentsCommentIdVoteData, ThrowOnError>) => (options.client ?? client).post<PostApiV1CommentsCommentIdVoteResponses, PostApiV1CommentsCommentIdVoteErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/comments/{comment_id}/vote',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postApiV1CommentsParentCommentIdComment = <ThrowOnError extends boolean = false>(options: Options<PostApiV1CommentsParentCommentIdCommentData, ThrowOnError>) => (options.client ?? client).post<PostApiV1CommentsParentCommentIdCommentResponses, PostApiV1CommentsParentCommentIdCommentErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/comments/{parent_comment_id}/comment',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postApiV1CommentsCommentIdApprove = <ThrowOnError extends boolean = false>(options: Options<PostApiV1CommentsCommentIdApproveData, ThrowOnError>) => (options.client ?? client).post<PostApiV1CommentsCommentIdApproveResponses, PostApiV1CommentsCommentIdApproveErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/comments/{comment_id}/approve',
    ...options
});

export const postApiV1CommentsCommentIdUnapprove = <ThrowOnError extends boolean = false>(options: Options<PostApiV1CommentsCommentIdUnapproveData, ThrowOnError>) => (options.client ?? client).post<PostApiV1CommentsCommentIdUnapproveResponses, PostApiV1CommentsCommentIdUnapproveErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/comments/{comment_id}/unapprove',
    ...options
});

export const getApiV1IdeaBoardEntriesExcel = <ThrowOnError extends boolean = false>(options: Options<GetApiV1IdeaBoardEntriesExcelData, ThrowOnError>) => (options.client ?? client).get<GetApiV1IdeaBoardEntriesExcelResponses, GetApiV1IdeaBoardEntriesExcelErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idea-board-entries/excel',
    ...options
});

export const getApiV1Comments = <ThrowOnError extends boolean = false>(options: Options<GetApiV1CommentsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1CommentsResponses, GetApiV1CommentsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/comments',
    ...options
});

export const getApiV1EventLogs = <ThrowOnError extends boolean = false>(options: Options<GetApiV1EventLogsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1EventLogsResponses, GetApiV1EventLogsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/event-logs',
    ...options
});

export const postApiV1MessagingSendMessage = <ThrowOnError extends boolean = false>(options: Options<PostApiV1MessagingSendMessageData, ThrowOnError>) => (options.client ?? client).post<PostApiV1MessagingSendMessageResponses, PostApiV1MessagingSendMessageErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/messaging/send-message',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postApiV1MessagingSendTestMessage = <ThrowOnError extends boolean = false>(options: Options<PostApiV1MessagingSendTestMessageData, ThrowOnError>) => (options.client ?? client).post<PostApiV1MessagingSendTestMessageResponses, PostApiV1MessagingSendTestMessageErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/messaging/send-test-message',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiV1Submissions = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SubmissionsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SubmissionsResponses, GetApiV1SubmissionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/submissions',
    ...options
});

export const putApiV1SubmissionsId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SubmissionsIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SubmissionsIdResponses, PutApiV1SubmissionsIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/submissions/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiV1SubmissionsPublic = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SubmissionsPublicData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SubmissionsPublicResponses, GetApiV1SubmissionsPublicErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/submissions/public',
    ...options
});

export const putApiV1ParticipantGroupsSyncTags = <ThrowOnError extends boolean = false>(options: Options<PutApiV1ParticipantGroupsSyncTagsData, ThrowOnError>) => (options.client ?? client).put<PutApiV1ParticipantGroupsSyncTagsResponses, PutApiV1ParticipantGroupsSyncTagsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participant-groups/sync-tags',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const putApiV1ParticipantGroupsParticipantGroupIdSyncToStage = <ThrowOnError extends boolean = false>(options: Options<PutApiV1ParticipantGroupsParticipantGroupIdSyncToStageData, ThrowOnError>) => (options.client ?? client).put<PutApiV1ParticipantGroupsParticipantGroupIdSyncToStageResponses, PutApiV1ParticipantGroupsParticipantGroupIdSyncToStageErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participant-groups/{participantGroup_id}/sync-to-stage',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const putApiV1ParticipantGroupsUpdateState = <ThrowOnError extends boolean = false>(options: Options<PutApiV1ParticipantGroupsUpdateStateData, ThrowOnError>) => (options.client ?? client).put<PutApiV1ParticipantGroupsUpdateStateResponses, PutApiV1ParticipantGroupsUpdateStateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participant-groups/update-state',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiV1ParticipantGroups = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1ParticipantGroupsData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1ParticipantGroupsResponses, GetApiV1ParticipantGroupsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participant-groups',
    ...options
});

export const postApiV1ParticipantGroups = <ThrowOnError extends boolean = false>(options: Options<PostApiV1ParticipantGroupsData, ThrowOnError>) => (options.client ?? client).post<PostApiV1ParticipantGroupsResponses, PostApiV1ParticipantGroupsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participant-groups',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteApiV1ParticipantGroupsParticipantGroupId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1ParticipantGroupsParticipantGroupIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1ParticipantGroupsParticipantGroupIdResponses, DeleteApiV1ParticipantGroupsParticipantGroupIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participant-groups/{participant_group_id}',
    ...options
});

/**
 * /api/v1/participant-groups/{participant_group_id}
 *
 * Show a participant group.
 */
export const getApiV1ParticipantGroupsParticipantGroupId = <ThrowOnError extends boolean = false>(options: Options<GetApiV1ParticipantGroupsParticipantGroupIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1ParticipantGroupsParticipantGroupIdResponses, GetApiV1ParticipantGroupsParticipantGroupIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participant-groups/{participant_group_id}',
    ...options
});

export const putApiV1ParticipantGroupsParticipantGroupId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1ParticipantGroupsParticipantGroupIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1ParticipantGroupsParticipantGroupIdResponses, PutApiV1ParticipantGroupsParticipantGroupIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participant-groups/{participant_group_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postApiV1ParticipantGroupsDelete = <ThrowOnError extends boolean = false>(options: Options<PostApiV1ParticipantGroupsDeleteData, ThrowOnError>) => (options.client ?? client).post<PostApiV1ParticipantGroupsDeleteResponses, PostApiV1ParticipantGroupsDeleteErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participant-groups/delete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteApiV1SpacesSpaceIdUsersUserId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SpacesSpaceIdUsersUserIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SpacesSpaceIdUsersUserIdResponses, DeleteApiV1SpacesSpaceIdUsersUserIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/{space_id}/users/{user_id}',
    ...options
});

export const getApiV1ParticipantGroupsExportUrl = <ThrowOnError extends boolean = false>(options: Options<GetApiV1ParticipantGroupsExportUrlData, ThrowOnError>) => (options.client ?? client).get<GetApiV1ParticipantGroupsExportUrlResponses, GetApiV1ParticipantGroupsExportUrlErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participant-groups/export-url',
    ...options
});

export const getApiV1ParticipantGroupsParticipantGroupIdUsers = <ThrowOnError extends boolean = false>(options: Options<GetApiV1ParticipantGroupsParticipantGroupIdUsersData, ThrowOnError>) => (options.client ?? client).get<GetApiV1ParticipantGroupsParticipantGroupIdUsersResponses, GetApiV1ParticipantGroupsParticipantGroupIdUsersErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participant-groups/{participantGroup_id}/users',
    ...options
});

export const postApiV1ParticipantGroupsParticipantGroupIdUsers = <ThrowOnError extends boolean = false>(options: Options<PostApiV1ParticipantGroupsParticipantGroupIdUsersData, ThrowOnError>) => (options.client ?? client).post<PostApiV1ParticipantGroupsParticipantGroupIdUsersResponses, PostApiV1ParticipantGroupsParticipantGroupIdUsersErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participant-groups/{participantGroup_id}/users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteApiV1ParticipantGroupsParticipantGroupIdUsersSpaceUserId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1ParticipantGroupsParticipantGroupIdUsersSpaceUserIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1ParticipantGroupsParticipantGroupIdUsersSpaceUserIdResponses, DeleteApiV1ParticipantGroupsParticipantGroupIdUsersSpaceUserIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participant-groups/{participantGroup_id}/users/{spaceUser_id}',
    ...options
});

export const getApiV1ParticipantGroupsParticipantGroupIdFeedbackForSurveySurveyIdPdf = <ThrowOnError extends boolean = false>(options: Options<GetApiV1ParticipantGroupsParticipantGroupIdFeedbackForSurveySurveyIdPdfData, ThrowOnError>) => (options.client ?? client).get<GetApiV1ParticipantGroupsParticipantGroupIdFeedbackForSurveySurveyIdPdfResponses, GetApiV1ParticipantGroupsParticipantGroupIdFeedbackForSurveySurveyIdPdfErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participant-groups/{participantGroup_id}/feedback-for-survey/{survey_id}/pdf',
    ...options
});

export const putApiV1ParticipantGroupsParticipantGroupIdAssociateOfflineSubmissionPdf = <ThrowOnError extends boolean = false>(options: Options<PutApiV1ParticipantGroupsParticipantGroupIdAssociateOfflineSubmissionPdfData, ThrowOnError>) => (options.client ?? client).put<PutApiV1ParticipantGroupsParticipantGroupIdAssociateOfflineSubmissionPdfResponses, PutApiV1ParticipantGroupsParticipantGroupIdAssociateOfflineSubmissionPdfErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participant-groups/{participantGroup_id}/associate-offline-submission-pdf',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const putApiV1ParticipantGroupsParticipantGroupIdDisassociateOfflineSubmissionPdf = <ThrowOnError extends boolean = false>(options: Options<PutApiV1ParticipantGroupsParticipantGroupIdDisassociateOfflineSubmissionPdfData, ThrowOnError>) => (options.client ?? client).put<PutApiV1ParticipantGroupsParticipantGroupIdDisassociateOfflineSubmissionPdfResponses, PutApiV1ParticipantGroupsParticipantGroupIdDisassociateOfflineSubmissionPdfErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participant-groups/{participantGroup_id}/disassociate-offline-submission-pdf',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Change team admin of a participant group.
 *
 * Requirements:
 * - Space Admin & Survey Admins (only for surveys they admin and attached to the group) can change team admin.
 * - Participants can only change if they are already the team admin of the group.
 * - New admin must already be a member of the group.
 * - When called: update group_admin_user_id, copy contact fields, sync pivot, and log the transfer.
 */
export const postChangeTeamAdminOfAParticipantGroup = <ThrowOnError extends boolean = false>(options: Options<PostChangeTeamAdminOfAParticipantGroupData, ThrowOnError>) => (options.client ?? client).post<PostChangeTeamAdminOfAParticipantGroupResponses, PostChangeTeamAdminOfAParticipantGroupErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participant-groups/{participantGroup_id}/change-admin',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postApiV1Participants = <ThrowOnError extends boolean = false>(options: Options<PostApiV1ParticipantsData, ThrowOnError>) => (options.client ?? client).post<PostApiV1ParticipantsResponses, PostApiV1ParticipantsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participants',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postApiV1ParticipantsCsv = <ThrowOnError extends boolean = false>(options: Options<PostApiV1ParticipantsCsvData, ThrowOnError>) => (options.client ?? client).post<PostApiV1ParticipantsCsvResponses, PostApiV1ParticipantsCsvErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participants/csv',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiV1ParticipantsImportTemplate = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1ParticipantsImportTemplateData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1ParticipantsImportTemplateResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participants/import-template',
    ...options
});

export const postApiV1ParticipantsImportFromTemplate = <ThrowOnError extends boolean = false>(options: Options<PostApiV1ParticipantsImportFromTemplateData, ThrowOnError>) => (options.client ?? client).post<PostApiV1ParticipantsImportFromTemplateResponses, PostApiV1ParticipantsImportFromTemplateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participants/import-from-template',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postApiV1ParticipantsCheckCsv = <ThrowOnError extends boolean = false>(options: Options<PostApiV1ParticipantsCheckCsvData, ThrowOnError>) => (options.client ?? client).post<PostApiV1ParticipantsCheckCsvResponses, PostApiV1ParticipantsCheckCsvErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participants/check-csv',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiV1ParticipantsGetCountOnStage = <ThrowOnError extends boolean = false>(options: Options<GetApiV1ParticipantsGetCountOnStageData, ThrowOnError>) => (options.client ?? client).get<GetApiV1ParticipantsGetCountOnStageResponses, GetApiV1ParticipantsGetCountOnStageErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participants/get-count-on-stage',
    ...options
});

export const putApiV1ParticipantsImportFromStage = <ThrowOnError extends boolean = false>(options: Options<PutApiV1ParticipantsImportFromStageData, ThrowOnError>) => (options.client ?? client).put<PutApiV1ParticipantsImportFromStageResponses, PutApiV1ParticipantsImportFromStageErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participants/import-from-stage',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postApiV1ParticipantsGetOrCreateParticipantGroupForAdmin = <ThrowOnError extends boolean = false>(options: Options<PostApiV1ParticipantsGetOrCreateParticipantGroupForAdminData, ThrowOnError>) => (options.client ?? client).post<PostApiV1ParticipantsGetOrCreateParticipantGroupForAdminResponses, PostApiV1ParticipantsGetOrCreateParticipantGroupForAdminErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participants/get-or-create-participant-group-for-admin',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiV1ParticipantGroupTags = <ThrowOnError extends boolean = false>(options: Options<GetApiV1ParticipantGroupTagsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1ParticipantGroupTagsResponses, GetApiV1ParticipantGroupTagsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/participant-group-tags',
    ...options
});

export const postApiV1ParticipantGroupTags = <ThrowOnError extends boolean = false>(options: Options<PostApiV1ParticipantGroupTagsData, ThrowOnError>) => (options.client ?? client).post<PostApiV1ParticipantGroupTagsResponses, PostApiV1ParticipantGroupTagsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participant-group-tags',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteApiV1ParticipantGroupTagsId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1ParticipantGroupTagsIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1ParticipantGroupTagsIdResponses, DeleteApiV1ParticipantGroupTagsIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participant-group-tags/{id}',
    ...options
});

export const getApiV1ParticipantGroupTagsId = <ThrowOnError extends boolean = false>(options: Options<GetApiV1ParticipantGroupTagsIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1ParticipantGroupTagsIdResponses, GetApiV1ParticipantGroupTagsIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participant-group-tags/{id}',
    ...options
});

export const putApiV1ParticipantGroupTagsId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1ParticipantGroupTagsIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1ParticipantGroupTagsIdResponses, PutApiV1ParticipantGroupTagsIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participant-group-tags/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * /api/v1/participant-import-files
 *
 * List participant import files.
 */
export const getApiV1ParticipantImportFiles = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1ParticipantImportFilesData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1ParticipantImportFilesResponses, GetApiV1ParticipantImportFilesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participant-import-files',
    ...options
});

/**
 * /api/v1/participant-import-files
 *
 * Upload a participant import file.
 */
export const postApiV1ParticipantImportFiles = <ThrowOnError extends boolean = false>(options: Options<PostApiV1ParticipantImportFilesData, ThrowOnError>) => (options.client ?? client).post<PostApiV1ParticipantImportFilesResponses, PostApiV1ParticipantImportFilesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participant-import-files',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * /api/v1/participant-import-files/{id}
 *
 * Delete a participant import file.
 */
export const deleteApiV1ParticipantImportFilesId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1ParticipantImportFilesIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1ParticipantImportFilesIdResponses, DeleteApiV1ParticipantImportFilesIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participant-import-files/{id}',
    ...options
});

/**
 * /api/v1/participant-import-files/{id}
 *
 * Show a participant import file.
 */
export const getApiV1ParticipantImportFilesId = <ThrowOnError extends boolean = false>(options: Options<GetApiV1ParticipantImportFilesIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1ParticipantImportFilesIdResponses, GetApiV1ParticipantImportFilesIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participant-import-files/{id}',
    ...options
});

/**
 * /api/v1/participant-import-files/{id}
 *
 * Update a participant import file.
 */
export const putApiV1ParticipantImportFilesId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1ParticipantImportFilesIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1ParticipantImportFilesIdResponses, PutApiV1ParticipantImportFilesIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participant-import-files/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiV1ParticipantGroupsExport = <ThrowOnError extends boolean = false>(options: Options<GetApiV1ParticipantGroupsExportData, ThrowOnError>) => (options.client ?? client).get<GetApiV1ParticipantGroupsExportResponses, GetApiV1ParticipantGroupsExportErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participant-groups/export',
    ...options
});

export const getApiV1PlatformFeedbacks = <ThrowOnError extends boolean = false>(options: Options<GetApiV1PlatformFeedbacksData, ThrowOnError>) => (options.client ?? client).get<GetApiV1PlatformFeedbacksResponses, GetApiV1PlatformFeedbacksErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/platform-feedbacks',
    ...options
});

export const postApiV1PlatformFeedbacks = <ThrowOnError extends boolean = false>(options: Options<PostApiV1PlatformFeedbacksData, ThrowOnError>) => (options.client ?? client).post<PostApiV1PlatformFeedbacksResponses, PostApiV1PlatformFeedbacksErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/platform-feedbacks',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiV1PlatformFeedbacksId = <ThrowOnError extends boolean = false>(options: Options<GetApiV1PlatformFeedbacksIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1PlatformFeedbacksIdResponses, GetApiV1PlatformFeedbacksIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/platform-feedbacks/{id}',
    ...options
});

export const putApiV1PlatformFeedbacksId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1PlatformFeedbacksIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1PlatformFeedbacksIdResponses, PutApiV1PlatformFeedbacksIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/platform-feedbacks/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postApiV1SpacesSpaceIdAdmins = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SpacesSpaceIdAdminsData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SpacesSpaceIdAdminsResponses, PostApiV1SpacesSpaceIdAdminsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/{space_id}/admins',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteApiV1SpacesSpaceIdAdminsSpaceUserId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SpacesSpaceIdAdminsSpaceUserIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SpacesSpaceIdAdminsSpaceUserIdResponses, DeleteApiV1SpacesSpaceIdAdminsSpaceUserIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/{space_id}/admins/{spaceUser_id}',
    ...options
});

/**
 * /api/v1/spaces
 *
 * Spaces list.
 */
export const getApiV1Spaces = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1SpacesData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1SpacesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/spaces',
    ...options
});

export const postApiV1Spaces = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SpacesData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SpacesResponses, PostApiV1SpacesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiV1SpacesId = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SpacesIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SpacesIdResponses, GetApiV1SpacesIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/{id}',
    ...options
});

export const putApiV1SpacesId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SpacesIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SpacesIdResponses, PutApiV1SpacesIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteApiV1SpacesSpaceIdTermsOfUsePdf = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SpacesSpaceIdTermsOfUsePdfData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SpacesSpaceIdTermsOfUsePdfResponses, DeleteApiV1SpacesSpaceIdTermsOfUsePdfErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/{space_id}/terms-of-use-pdf',
    ...options
});

export const deleteApiV1SpacesSpaceIdFavicon = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SpacesSpaceIdFaviconData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SpacesSpaceIdFaviconResponses, DeleteApiV1SpacesSpaceIdFaviconErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/spaces/{space_id}/favicon',
    ...options
});

/**
 * /api/v1/all-spaces
 *
 * List all spaces.
 */
export const getApiV1AllSpaces = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1AllSpacesData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1AllSpacesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/all-spaces',
    ...options
});

export const getApiV1SpacesSpaceIdLogo = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SpacesSpaceIdLogoData, ThrowOnError>) => (options.client ?? client).get<unknown, GetApiV1SpacesSpaceIdLogoErrors, ThrowOnError>({ url: '/api/v1/spaces/{space_id}/logo', ...options });

export const getApiV1SpaceAssets = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1SpaceAssetsData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1SpaceAssetsResponses, GetApiV1SpaceAssetsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/space-assets',
    ...options
});

export const postApiV1SpaceAssets = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SpaceAssetsData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SpaceAssetsResponses, PostApiV1SpaceAssetsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/space-assets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteApiV1SpaceAssetsId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SpaceAssetsIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SpaceAssetsIdResponses, DeleteApiV1SpaceAssetsIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/space-assets/{id}',
    ...options
});

export const getApiV1SpaceAssetsId = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SpaceAssetsIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SpaceAssetsIdResponses, GetApiV1SpaceAssetsIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/space-assets/{id}',
    ...options
});

export const putApiV1SpaceAssetsId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SpaceAssetsIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SpaceAssetsIdResponses, PutApiV1SpaceAssetsIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/space-assets/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiV1SpaceAssetsSpaceAssetIdDownloadFilename = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SpaceAssetsSpaceAssetIdDownloadFilenameData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SpaceAssetsSpaceAssetIdDownloadFilenameResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/space-assets/{spaceAsset_id}/download/{filename}',
    ...options
});

export const deleteApiV1SpaceUsersSpaceUserId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SpaceUsersSpaceUserIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SpaceUsersSpaceUserIdResponses, DeleteApiV1SpaceUsersSpaceUserIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/space-users/{spaceUser_id}',
    ...options
});

export const putApiV1SpaceUsersSpaceUserId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SpaceUsersSpaceUserIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SpaceUsersSpaceUserIdResponses, PutApiV1SpaceUsersSpaceUserIdErrors, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/space-users/{spaceUser_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postApiV1SpaceUsersUnionConflictedSpaceUsersAndLogin = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1SpaceUsersUnionConflictedSpaceUsersAndLoginData, ThrowOnError>) => (options?.client ?? client).post<PostApiV1SpaceUsersUnionConflictedSpaceUsersAndLoginResponses, PostApiV1SpaceUsersUnionConflictedSpaceUsersAndLoginErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/space-users/union-conflicted-space-users-and-login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const postApiV1SpaceUsersSpaceUserIdUnlock = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SpaceUsersSpaceUserIdUnlockData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SpaceUsersSpaceUserIdUnlockResponses, PostApiV1SpaceUsersSpaceUserIdUnlockErrors, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/space-users/{spaceUser_id}/unlock',
    ...options
});

export const getApiV1SpaceUsers = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1SpaceUsersData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1SpaceUsersResponses, GetApiV1SpaceUsersErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/space-users',
    ...options
});

export const getApiV1EvaluationPageSettings = <ThrowOnError extends boolean = false>(options: Options<GetApiV1EvaluationPageSettingsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1EvaluationPageSettingsResponses, GetApiV1EvaluationPageSettingsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/evaluation-page-settings',
    ...options
});

export const postApiV1EvaluationPageSettings = <ThrowOnError extends boolean = false>(options: Options<PostApiV1EvaluationPageSettingsData, ThrowOnError>) => (options.client ?? client).post<PostApiV1EvaluationPageSettingsResponses, PostApiV1EvaluationPageSettingsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/evaluation-page-settings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteApiV1EvaluationPageSettingsId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1EvaluationPageSettingsIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1EvaluationPageSettingsIdResponses, DeleteApiV1EvaluationPageSettingsIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/evaluation-page-settings/{id}',
    ...options
});

export const putApiV1EvaluationPageSettingsId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1EvaluationPageSettingsIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1EvaluationPageSettingsIdResponses, PutApiV1EvaluationPageSettingsIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/evaluation-page-settings/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiV1StorageFilesPath = <ThrowOnError extends boolean = false>(options: Options<GetApiV1StorageFilesPathData, ThrowOnError>) => (options.client ?? client).get<unknown, unknown, ThrowOnError>({ url: '/api/v1/storage/files/{path}', ...options });

export const getApiV1SupportZohoOauth = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1SupportZohoOauthData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1SupportZohoOauthResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/support/zoho-oauth',
    ...options
});

export const postApiV1SupportRequests = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SupportRequestsData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SupportRequestsResponses, PostApiV1SupportRequestsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/support/requests',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const putApiV1SurveysSurveyIdRemoveParticipantGroups = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SurveysSurveyIdRemoveParticipantGroupsData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SurveysSurveyIdRemoveParticipantGroupsResponses, PutApiV1SurveysSurveyIdRemoveParticipantGroupsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/surveys/{survey_id}/remove-participant-groups',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiV1SurveysSurveyIdUsers = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveysSurveyIdUsersData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveysSurveyIdUsersResponses, GetApiV1SurveysSurveyIdUsersErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/surveys/{survey_id}/users',
    ...options
});

export const postApiV1SurveysSurveyIdUsers = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveysSurveyIdUsersData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SurveysSurveyIdUsersResponses, PostApiV1SurveysSurveyIdUsersErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/surveys/{survey_id}/users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteApiV1SurveysSurveyIdUsersSpaceUserId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SurveysSurveyIdUsersSpaceUserIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SurveysSurveyIdUsersSpaceUserIdResponses, DeleteApiV1SurveysSurveyIdUsersSpaceUserIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/surveys/{survey_id}/users/{spaceUser_id}',
    ...options
});

export const getApiV1SurveysSurveyIdTags = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveysSurveyIdTagsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveysSurveyIdTagsResponses, GetApiV1SurveysSurveyIdTagsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/surveys/{survey_id}/tags',
    ...options
});

export const postApiV1SurveysSurveyIdSendInvitationEmail = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveysSurveyIdSendInvitationEmailData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SurveysSurveyIdSendInvitationEmailResponses, PostApiV1SurveysSurveyIdSendInvitationEmailErrors, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/surveys/{survey_id}/send-invitation-email',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postApiV1SurveysSurveyIdSendRecordingReminder = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveysSurveyIdSendRecordingReminderData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SurveysSurveyIdSendRecordingReminderResponses, PostApiV1SurveysSurveyIdSendRecordingReminderErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/surveys/{survey_id}/send-recording-reminder',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postApiV1SurveysSurveyIdSendSubmittingReminder = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveysSurveyIdSendSubmittingReminderData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SurveysSurveyIdSendSubmittingReminderResponses, PostApiV1SurveysSurveyIdSendSubmittingReminderErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/surveys/{survey_id}/send-submitting-reminder',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postApiV1SurveysSurveyIdSendParticipantReactionReport = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveysSurveyIdSendParticipantReactionReportData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SurveysSurveyIdSendParticipantReactionReportResponses, PostApiV1SurveysSurveyIdSendParticipantReactionReportErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/surveys/{survey_id}/send-participant-reaction-report',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiV1SurveysSurveyIdKeyFigures = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveysSurveyIdKeyFiguresData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveysSurveyIdKeyFiguresResponses, GetApiV1SurveysSurveyIdKeyFiguresErrors, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/surveys/{survey_id}/key-figures',
    ...options
});

export const getApiV1SurveysSurveyIdStats = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveysSurveyIdStatsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveysSurveyIdStatsResponses, GetApiV1SurveysSurveyIdStatsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/surveys/{survey_id}/stats',
    ...options
});

export const postApiV1SurveysSurveyIdSubmit = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveysSurveyIdSubmitData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SurveysSurveyIdSubmitResponses, PostApiV1SurveysSurveyIdSubmitErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/surveys/{survey_id}/submit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postApiV1SurveysSurveyIdRevokeSubmit = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveysSurveyIdRevokeSubmitData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SurveysSurveyIdRevokeSubmitResponses, PostApiV1SurveysSurveyIdRevokeSubmitErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/surveys/{survey_id}/revoke-submit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postApiV1SurveysSurveyIdPublishSubmission = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveysSurveyIdPublishSubmissionData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SurveysSurveyIdPublishSubmissionResponses, PostApiV1SurveysSurveyIdPublishSubmissionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/surveys/{survey_id}/publish-submission',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postApiV1SurveysSurveyIdDispatchSearchForSimilarEvaluationGroups = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveysSurveyIdDispatchSearchForSimilarEvaluationGroupsData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SurveysSurveyIdDispatchSearchForSimilarEvaluationGroupsResponses, PostApiV1SurveysSurveyIdDispatchSearchForSimilarEvaluationGroupsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/surveys/{survey_id}/dispatch-search-for-similar-evaluation-groups',
    ...options
});

export const putApiV1SurveysSurveyIdArchive = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SurveysSurveyIdArchiveData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SurveysSurveyIdArchiveResponses, PutApiV1SurveysSurveyIdArchiveErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/surveys/{survey_id}/archive',
    ...options
});

export const putApiV1SurveysSurveyIdUnarchive = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SurveysSurveyIdUnarchiveData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SurveysSurveyIdUnarchiveResponses, PutApiV1SurveysSurveyIdUnarchiveErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/surveys/{survey_id}/unarchive',
    ...options
});

export const getApiV1SurveysGeneralReportDownload = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveysGeneralReportDownloadData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveysGeneralReportDownloadResponses, GetApiV1SurveysGeneralReportDownloadErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/surveys/general-report-download',
    ...options
});

export const getApiV1Surveys = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1SurveysData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1SurveysResponses, GetApiV1SurveysErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/surveys',
    ...options
});

export const postApiV1Surveys = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveysData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SurveysResponses, PostApiV1SurveysErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/surveys',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteApiV1SurveysId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SurveysIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SurveysIdResponses, DeleteApiV1SurveysIdErrors, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/surveys/{id}',
    ...options
});

/**
 * Update a survey.
 */
export const putUpdateASurvey = <ThrowOnError extends boolean = false>(options: Options<PutUpdateASurveyData, ThrowOnError>) => (options.client ?? client).put<PutUpdateASurveyResponses, PutUpdateASurveyErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/surveys/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postApiV1SurveysSurveyIdCopy = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveysSurveyIdCopyData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SurveysSurveyIdCopyResponses, PostApiV1SurveysSurveyIdCopyErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/surveys/{survey_id}/copy',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const putApiV1SurveyCategoriesSort = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SurveyCategoriesSortData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SurveyCategoriesSortResponses, PutApiV1SurveyCategoriesSortErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-categories/sort',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiV1SurveyCategories = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1SurveyCategoriesData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1SurveyCategoriesResponses, GetApiV1SurveyCategoriesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/survey-categories',
    ...options
});

export const postApiV1SurveyCategories = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveyCategoriesData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SurveyCategoriesResponses, PostApiV1SurveyCategoriesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-categories',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteApiV1SurveyCategoriesId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SurveyCategoriesIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SurveyCategoriesIdResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-categories/{id}',
    ...options
});

export const getApiV1SurveyCategoriesId = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyCategoriesIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyCategoriesIdResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/survey-categories/{id}',
    ...options
});

export const putApiV1SurveyCategoriesId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SurveyCategoriesIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SurveyCategoriesIdResponses, PutApiV1SurveyCategoriesIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-categories/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiV1SurveyExports = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyExportsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyExportsResponses, GetApiV1SurveyExportsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-exports',
    ...options
});

export const postApiV1SurveyExports = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveyExportsData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SurveyExportsResponses, PostApiV1SurveyExportsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-exports',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteApiV1SurveyExportsId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SurveyExportsIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SurveyExportsIdResponses, DeleteApiV1SurveyExportsIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-exports/{id}',
    ...options
});

export const getApiV1SurveyExportsId = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyExportsIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyExportsIdResponses, GetApiV1SurveyExportsIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-exports/{id}',
    ...options
});

export const getApiV1SurveyExportsSurveyExportIdDownloadUrl = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyExportsSurveyExportIdDownloadUrlData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyExportsSurveyExportIdDownloadUrlResponses, GetApiV1SurveyExportsSurveyExportIdDownloadUrlErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-exports/{surveyExport_id}/download-url',
    ...options
});

export const getApiV1SurveysSurveyBySlug = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveysSurveyBySlugData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveysSurveyBySlugResponses, GetApiV1SurveysSurveyBySlugErrors, ThrowOnError>({
    responseType: 'text',
    url: '/api/v1/surveys/{surveyBySlug}',
    ...options
});

export const getApiV1SurveysSurveyBySlugLogo = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveysSurveyBySlugLogoData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveysSurveyBySlugLogoResponses, unknown, ThrowOnError>({
    responseType: 'text',
    url: '/api/v1/surveys/{surveyBySlug}/logo',
    ...options
});

export const getApiV1SurveyTags = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1SurveyTagsData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1SurveyTagsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/survey-tags',
    ...options
});

/**
 * /api/v1/survey-document-group-tags
 *
 * List document group tags.
 */
export const getApiV1SurveyDocumentGroupTags = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentGroupTagsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyDocumentGroupTagsResponses, GetApiV1SurveyDocumentGroupTagsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-group-tags',
    ...options
});

/**
 * /api/v1/survey-document-group-tags
 *
 * Create a document group tag.
 */
export const postApiV1SurveyDocumentGroupTags = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveyDocumentGroupTagsData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SurveyDocumentGroupTagsResponses, PostApiV1SurveyDocumentGroupTagsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-group-tags',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * /api/v1/survey-document-group-tags/{id}
 *
 * Delete a document group tag.
 */
export const deleteApiV1SurveyDocumentGroupTagsId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SurveyDocumentGroupTagsIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SurveyDocumentGroupTagsIdResponses, DeleteApiV1SurveyDocumentGroupTagsIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-group-tags/{id}',
    ...options
});

/**
 * /api/v1/survey-document-group-tags/{id}
 *
 * Show a document group tag.
 */
export const getApiV1SurveyDocumentGroupTagsId = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentGroupTagsIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyDocumentGroupTagsIdResponses, GetApiV1SurveyDocumentGroupTagsIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-group-tags/{id}',
    ...options
});

/**
 * /api/v1/survey-document-group-tags/{id}
 *
 * Update a document group tag.
 */
export const putApiV1SurveyDocumentGroupTagsId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SurveyDocumentGroupTagsIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SurveyDocumentGroupTagsIdResponses, PutApiV1SurveyDocumentGroupTagsIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-group-tags/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const putApiV1SurveyDocumentGroupsSort = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SurveyDocumentGroupsSortData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SurveyDocumentGroupsSortResponses, PutApiV1SurveyDocumentGroupsSortErrors, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-groups/sort',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * /api/v1/survey-document-groups
 *
 * List document groups.
 */
export const getApiV1SurveyDocumentGroups = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1SurveyDocumentGroupsData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1SurveyDocumentGroupsResponses, GetApiV1SurveyDocumentGroupsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/survey-document-groups',
    ...options
});

/**
 * /api/v1/survey-document-groups
 *
 * Create a document group.
 */
export const postApiV1SurveyDocumentGroups = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveyDocumentGroupsData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SurveyDocumentGroupsResponses, PostApiV1SurveyDocumentGroupsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-groups',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteApiV1SurveyDocumentGroupsId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SurveyDocumentGroupsIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SurveyDocumentGroupsIdResponses, DeleteApiV1SurveyDocumentGroupsIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-groups/{id}',
    ...options
});

/**
 * /api/v1/survey-document-groups/{id}
 *
 * Show a document group.
 */
export const getApiV1SurveyDocumentGroupsId = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentGroupsIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyDocumentGroupsIdResponses, GetApiV1SurveyDocumentGroupsIdErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/survey-document-groups/{id}',
    ...options
});

/**
 * /api/v1/survey-document-groups/{id}
 *
 * Update a document group.
 */
export const putApiV1SurveyDocumentGroupsId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SurveyDocumentGroupsIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SurveyDocumentGroupsIdResponses, PutApiV1SurveyDocumentGroupsIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-groups/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const putApiV1SurveyDocumentsSort = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SurveyDocumentsSortData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SurveyDocumentsSortResponses, PutApiV1SurveyDocumentsSortErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-documents/sort',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiV1SurveyDocumentsSurveyDocumentIdQuestionAnswersExcelExportUrl = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentsSurveyDocumentIdQuestionAnswersExcelExportUrlData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyDocumentsSurveyDocumentIdQuestionAnswersExcelExportUrlResponses, GetApiV1SurveyDocumentsSurveyDocumentIdQuestionAnswersExcelExportUrlErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-documents/{survey_document_id}/question-answers-excel-export-url',
    ...options
});

/**
 * /api/v1/survey-documents
 *
 * List survey documents.
 */
export const getApiV1SurveyDocuments = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1SurveyDocumentsData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1SurveyDocumentsResponses, GetApiV1SurveyDocumentsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/survey-documents',
    ...options
});

/**
 * /api/v1/survey-documents
 *
 * Create a new survey document.
 */
export const postApiV1SurveyDocuments = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveyDocumentsData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SurveyDocumentsResponses, PostApiV1SurveyDocumentsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-documents',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * /api/v1/survey-documents/{id}
 *
 * Delete a survey document.
 */
export const deleteApiV1SurveyDocumentsId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SurveyDocumentsIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SurveyDocumentsIdResponses, DeleteApiV1SurveyDocumentsIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-documents/{id}',
    ...options
});

/**
 * /api/v1/survey-documents/{id}
 *
 * Show a survey document.
 */
export const getApiV1SurveyDocumentsId = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentsIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyDocumentsIdResponses, GetApiV1SurveyDocumentsIdErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/survey-documents/{id}',
    ...options
});

/**
 * /api/v1/survey-documents/{id}
 *
 * Update a survey document.
 */
export const putApiV1SurveyDocumentsId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SurveyDocumentsIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SurveyDocumentsIdResponses, PutApiV1SurveyDocumentsIdErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-documents/{id}',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

export const postApiV1SurveyDocumentPageAreasStoreMass = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveyDocumentPageAreasStoreMassData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SurveyDocumentPageAreasStoreMassResponses, PostApiV1SurveyDocumentPageAreasStoreMassErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-page-areas/store-mass',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * /api/v1/survey-document-page-areas/copy-language
 *
 * Copy all page areas of a survey document from the current language into another language (only when the target language has none).
 */
export const postApiV1SurveyDocumentPageAreasCopyLanguage = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveyDocumentPageAreasCopyLanguageData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SurveyDocumentPageAreasCopyLanguageResponses, PostApiV1SurveyDocumentPageAreasCopyLanguageErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-page-areas/copy-language',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * /api/v1/survey-document-page-areas/by-language
 *
 * Delete all page areas of a survey document in the current language.
 */
export const deleteApiV1SurveyDocumentPageAreasByLanguage = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SurveyDocumentPageAreasByLanguageData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SurveyDocumentPageAreasByLanguageResponses, DeleteApiV1SurveyDocumentPageAreasByLanguageErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-page-areas/by-language',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * /api/v1/survey-document-page-areas/languages
 *
 * Count the page areas of a survey document per language of its space.
 */
export const getApiV1SurveyDocumentPageAreasLanguages = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentPageAreasLanguagesData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyDocumentPageAreasLanguagesResponses, GetApiV1SurveyDocumentPageAreasLanguagesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-page-areas/languages',
    ...options
});

/**
 * /api/v1/survey-document-page-areas
 *
 * List document page areas.
 */
export const getApiV1SurveyDocumentPageAreas = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentPageAreasData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyDocumentPageAreasResponses, GetApiV1SurveyDocumentPageAreasErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/survey-document-page-areas',
    ...options
});

/**
 * /api/v1/survey-document-page-areas
 *
 * Create a document page area.
 */
export const postApiV1SurveyDocumentPageAreas = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveyDocumentPageAreasData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SurveyDocumentPageAreasResponses, PostApiV1SurveyDocumentPageAreasErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-page-areas',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteApiV1SurveyDocumentPageAreasId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SurveyDocumentPageAreasIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SurveyDocumentPageAreasIdResponses, DeleteApiV1SurveyDocumentPageAreasIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-page-areas/{id}',
    ...options
});

export const putApiV1SurveyDocumentPageAreasId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SurveyDocumentPageAreasIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SurveyDocumentPageAreasIdResponses, PutApiV1SurveyDocumentPageAreasIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-document-page-areas/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiV1SurveyDocumentsSurveyDocumentIdQuestionAnswersExcel = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentsSurveyDocumentIdQuestionAnswersExcelData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyDocumentsSurveyDocumentIdQuestionAnswersExcelResponses, GetApiV1SurveyDocumentsSurveyDocumentIdQuestionAnswersExcelErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-documents/{surveyDocument_id}/question-answers-excel',
    ...options
});

export const getApiV1SurveyDocumentsSurveyDocumentIdPdf = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyDocumentsSurveyDocumentIdPdfData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyDocumentsSurveyDocumentIdPdfResponses, GetApiV1SurveyDocumentsSurveyDocumentIdPdfErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/survey-documents/{surveyDocument_id}/pdf',
    ...options
});

export const getApiV1SurveyModuleQuestions = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyModuleQuestionsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyModuleQuestionsResponses, GetApiV1SurveyModuleQuestionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-module-questions',
    ...options
});

export const postApiV1SurveyModuleQuestions = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveyModuleQuestionsData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SurveyModuleQuestionsResponses, PostApiV1SurveyModuleQuestionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-module-questions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteApiV1SurveyModuleQuestionsId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SurveyModuleQuestionsIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SurveyModuleQuestionsIdResponses, DeleteApiV1SurveyModuleQuestionsIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-module-questions/{id}',
    ...options
});

export const putApiV1SurveyModuleQuestionsId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SurveyModuleQuestionsIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SurveyModuleQuestionsIdResponses, PutApiV1SurveyModuleQuestionsIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-module-questions/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteApiV1SurveyModuleQuestionsSurveyModuleQuestionIdDeleteAnswers = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SurveyModuleQuestionsSurveyModuleQuestionIdDeleteAnswersData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SurveyModuleQuestionsSurveyModuleQuestionIdDeleteAnswersResponses, DeleteApiV1SurveyModuleQuestionsSurveyModuleQuestionIdDeleteAnswersErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-module-questions/{survey_module_question_id}/delete-answers',
    ...options
});

export const getApiV1SurveyModuleQuestionsSurveyModuleQuestionIdResults = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyModuleQuestionsSurveyModuleQuestionIdResultsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyModuleQuestionsSurveyModuleQuestionIdResultsResponses, GetApiV1SurveyModuleQuestionsSurveyModuleQuestionIdResultsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-module-questions/{survey_module_question_id}/results',
    ...options
});

export const getApiV1SurveyModuleAnswers = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyModuleAnswersData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyModuleAnswersResponses, GetApiV1SurveyModuleAnswersErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-module-answers',
    ...options
});

export const postApiV1SurveyModuleAnswers = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveyModuleAnswersData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SurveyModuleAnswersResponses, PostApiV1SurveyModuleAnswersErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-module-answers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteApiV1SurveyModuleAnswersId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SurveyModuleAnswersIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SurveyModuleAnswersIdResponses, DeleteApiV1SurveyModuleAnswersIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-module-answers/{id}',
    ...options
});

export const putApiV1SurveyModuleAnswersId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SurveyModuleAnswersIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SurveyModuleAnswersIdResponses, PutApiV1SurveyModuleAnswersIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-module-answers/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiV1SurveyModuleAnswersExcelExportUrl = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyModuleAnswersExcelExportUrlData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyModuleAnswersExcelExportUrlResponses, GetApiV1SurveyModuleAnswersExcelExportUrlErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-module-answers/excel-export-url',
    ...options
});

export const getApiV1SurveyModuleAnswersExcel = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyModuleAnswersExcelData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyModuleAnswersExcelResponses, GetApiV1SurveyModuleAnswersExcelErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-module-answers/excel',
    ...options
});

export const getApiV1SurveyStagesSurveyStageIdParticipantGroupsParticipantGroupIdCheckSubmittingRights = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyStagesSurveyStageIdParticipantGroupsParticipantGroupIdCheckSubmittingRightsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyStagesSurveyStageIdParticipantGroupsParticipantGroupIdCheckSubmittingRightsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-stages/{surveyStage_id}/participant-groups/{participantGroup_id}/check-submitting-rights',
    ...options
});

export const postApiV1SurveyStagesSurveyStageIdParticipantGroupsAttach = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveyStagesSurveyStageIdParticipantGroupsAttachData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SurveyStagesSurveyStageIdParticipantGroupsAttachResponses, PostApiV1SurveyStagesSurveyStageIdParticipantGroupsAttachErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-stages/{surveyStage_id}/participant-groups/attach',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postApiV1SurveyStagesSurveyStageIdParticipantGroupsDetach = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveyStagesSurveyStageIdParticipantGroupsDetachData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SurveyStagesSurveyStageIdParticipantGroupsDetachResponses, PostApiV1SurveyStagesSurveyStageIdParticipantGroupsDetachErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-stages/{surveyStage_id}/participant-groups/detach',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * /api/v1/survey-stages
 *
 * List survey stages.
 */
export const getApiV1SurveyStages = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyStagesData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyStagesResponses, GetApiV1SurveyStagesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-stages',
    ...options
});

/**
 * /api/v1/survey-stages
 *
 * Create a survey stage.
 */
export const postApiV1SurveyStages = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SurveyStagesData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SurveyStagesResponses, PostApiV1SurveyStagesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-stages',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * /api/v1/survey-stages/{id}
 *
 * Delete a survey stage.
 */
export const deleteApiV1SurveyStagesId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1SurveyStagesIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SurveyStagesIdResponses, DeleteApiV1SurveyStagesIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-stages/{id}',
    ...options
});

/**
 * /api/v1/survey-stages/{id}
 *
 * Show a survey stage.
 */
export const getApiV1SurveyStagesId = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SurveyStagesIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SurveyStagesIdResponses, GetApiV1SurveyStagesIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-stages/{id}',
    ...options
});

/**
 * /api/v1/survey-stages/{id}
 *
 * Update a survey stage.
 */
export const putApiV1SurveyStagesId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1SurveyStagesIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SurveyStagesIdResponses, PutApiV1SurveyStagesIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/survey-stages/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postApiV1TranslationsFlush = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1TranslationsFlushData, ThrowOnError>) => (options?.client ?? client).post<PostApiV1TranslationsFlushResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/translations/flush',
    ...options
});

export const postApiV1LocalesFlush = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1LocalesFlushData, ThrowOnError>) => (options?.client ?? client).post<PostApiV1LocalesFlushResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/locales/flush',
    ...options
});

export const getApiV1LocalesLangTranslationJson = <ThrowOnError extends boolean = false>(options: Options<GetApiV1LocalesLangTranslationJsonData, ThrowOnError>) => (options.client ?? client).get<GetApiV1LocalesLangTranslationJsonResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/locales/{lang}/translation.json',
    ...options
});

/**
 * /api/v1/oauth/user
 *
 * Get authenticated user.
 */
export const getApiV1OauthUser = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1OauthUserData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1OauthUserResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/oauth/user',
    ...options
});

export const putApiV1UsersUserId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1UsersUserIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1UsersUserIdResponses, PutApiV1UsersUserIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/{user_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const putApiV1UsersUserIdVerifyEmail = <ThrowOnError extends boolean = false>(options: Options<PutApiV1UsersUserIdVerifyEmailData, ThrowOnError>) => (options.client ?? client).put<PutApiV1UsersUserIdVerifyEmailResponses, PutApiV1UsersUserIdVerifyEmailErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/{user_id}/verify-email',
    ...options
});
